(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-core'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-core'.");
    }
    root['kotlinx-serialization-kotlinx-serialization-core'] = factory(typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined' ? {} : this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib-js-ir']);
  }
}(this, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.yc;
  var interfaceMeta = kotlin_kotlin.$_$.zb;
  var VOID = kotlin_kotlin.$_$.ni;
  var setMetadataFor = kotlin_kotlin.$_$.zc;
  var StringCompanionObject_getInstance = kotlin_kotlin.$_$.n4;
  var Unit_getInstance = kotlin_kotlin.$_$.a5;
  var emptyList = kotlin_kotlin.$_$.c7;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.bi;
  var classMeta = kotlin_kotlin.$_$.lb;
  var getKClassFromExpression = kotlin_kotlin.$_$.d;
  var KProperty1 = kotlin_kotlin.$_$.ae;
  var getPropertyCallableRef = kotlin_kotlin.$_$.vb;
  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.p1;
  var objectCreate = kotlin_kotlin.$_$.wc;
  var captureStack = kotlin_kotlin.$_$.fb;
  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.r1;
  var IllegalArgumentException = kotlin_kotlin.$_$.tg;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var THROW_CCE = kotlin_kotlin.$_$.ah;
  var KClass = kotlin_kotlin.$_$.wd;
  var isInterface = kotlin_kotlin.$_$.jc;
  var Triple = kotlin_kotlin.$_$.dh;
  var getKClass = kotlin_kotlin.$_$.e;
  var Pair = kotlin_kotlin.$_$.xg;
  var Entry = kotlin_kotlin.$_$.l5;
  var LinkedHashMap = kotlin_kotlin.$_$.i5;
  var MutableMap = kotlin_kotlin.$_$.q5;
  var Map = kotlin_kotlin.$_$.m5;
  var HashMap = kotlin_kotlin.$_$.f5;
  var LinkedHashSet = kotlin_kotlin.$_$.j5;
  var MutableSet = kotlin_kotlin.$_$.r5;
  var Set = kotlin_kotlin.$_$.t5;
  var HashSet = kotlin_kotlin.$_$.g5;
  var ArrayList = kotlin_kotlin.$_$.d5;
  var MutableList = kotlin_kotlin.$_$.o5;
  var List = kotlin_kotlin.$_$.k5;
  var Collection = kotlin_kotlin.$_$.e5;
  var copyToArray = kotlin_kotlin.$_$.a7;
  var toString = kotlin_kotlin.$_$.dd;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.t2;
  var isObject = kotlin_kotlin.$_$.mc;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.s2;
  var Result = kotlin_kotlin.$_$.yg;
  var ensureNotNull = kotlin_kotlin.$_$.th;
  var equals = kotlin_kotlin.$_$.ob;
  var getStringHashCode = kotlin_kotlin.$_$.wb;
  var Iterable = kotlin_kotlin.$_$.h5;
  var isBlank = kotlin_kotlin.$_$.pe;
  var toList = kotlin_kotlin.$_$.r9;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.m;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.s;
  var toHashSet = kotlin_kotlin.$_$.l9;
  var toBooleanArray = kotlin_kotlin.$_$.k9;
  var withIndex = kotlin_kotlin.$_$.ba;
  var to = kotlin_kotlin.$_$.mi;
  var toMap = kotlin_kotlin.$_$.u9;
  var lazy_0 = kotlin_kotlin.$_$.ci;
  var contentEquals = kotlin_kotlin.$_$.g6;
  var until = kotlin_kotlin.$_$.vd;
  var joinToString = kotlin_kotlin.$_$.x7;
  var objectMeta = kotlin_kotlin.$_$.xc;
  var Long = kotlin_kotlin.$_$.ug;
  var Char = kotlin_kotlin.$_$.lg;
  var Duration__toIsoString_impl_9h6wsm = kotlin_kotlin.$_$.g2;
  var Duration = kotlin_kotlin.$_$.jg;
  var Companion_getInstance = kotlin_kotlin.$_$.s4;
  var toIntOrNull = kotlin_kotlin.$_$.rf;
  var hashCode = kotlin_kotlin.$_$.xb;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t1;
  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.n;
  var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.t;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.x;
  var LinkedHashSet_init_$Create$_0 = kotlin_kotlin.$_$.y;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.p;
  var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.q;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.v;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.w;
  var isArray = kotlin_kotlin.$_$.ac;
  var arrayIterator = kotlin_kotlin.$_$.db;
  var asList = kotlin_kotlin.$_$.y5;
  var step = kotlin_kotlin.$_$.td;
  var getValue = kotlin_kotlin.$_$.t7;
  var longArray = kotlin_kotlin.$_$.pc;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.u4;
  var get_lastIndex = kotlin_kotlin.$_$.a8;
  var countTrailingZeroBits = kotlin_kotlin.$_$.rh;
  var HashSet_init_$Create$_1 = kotlin_kotlin.$_$.r;
  var KTypeParameter = kotlin_kotlin.$_$.be;
  var fillArrayVal = kotlin_kotlin.$_$.qb;
  var booleanArray = kotlin_kotlin.$_$.eb;
  var emptyMap = kotlin_kotlin.$_$.d7;
  var contentHashCode = kotlin_kotlin.$_$.m6;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.t4;
  var isCharArray = kotlin_kotlin.$_$.dc;
  var charArray = kotlin_kotlin.$_$.hb;
  var DoubleCompanionObject_getInstance = kotlin_kotlin.$_$.j4;
  var isDoubleArray = kotlin_kotlin.$_$.gc;
  var FloatCompanionObject_getInstance = kotlin_kotlin.$_$.k4;
  var isFloatArray = kotlin_kotlin.$_$.hc;
  var isLongArray = kotlin_kotlin.$_$.kc;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.y4;
  var _ULongArray___get_size__impl__ju6dtr = kotlin_kotlin.$_$.u3;
  var ULongArray = kotlin_kotlin.$_$.ih;
  var _ULongArray___init__impl__twm1l3 = kotlin_kotlin.$_$.q3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.n3;
  var ULongArray__get_impl_pr71q9 = kotlin_kotlin.$_$.s3;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.o3;
  var IntCompanionObject_getInstance = kotlin_kotlin.$_$.l4;
  var isIntArray = kotlin_kotlin.$_$.ic;
  var Companion_getInstance_3 = kotlin_kotlin.$_$.x4;
  var _UIntArray___get_size__impl__r6l8ci = kotlin_kotlin.$_$.l3;
  var UIntArray = kotlin_kotlin.$_$.gh;
  var _UIntArray___init__impl__ghjpc6 = kotlin_kotlin.$_$.h3;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.e3;
  var UIntArray__get_impl_gp5kza = kotlin_kotlin.$_$.j3;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.f3;
  var ShortCompanionObject_getInstance = kotlin_kotlin.$_$.m4;
  var isShortArray = kotlin_kotlin.$_$.nc;
  var Companion_getInstance_4 = kotlin_kotlin.$_$.z4;
  var _UShortArray___get_size__impl__jqto1b = kotlin_kotlin.$_$.d4;
  var UShortArray = kotlin_kotlin.$_$.kh;
  var _UShortArray___init__impl__9b26ef = kotlin_kotlin.$_$.z3;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.w3;
  var UShortArray__get_impl_fnbhmx = kotlin_kotlin.$_$.b4;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.x3;
  var ByteCompanionObject_getInstance = kotlin_kotlin.$_$.i4;
  var isByteArray = kotlin_kotlin.$_$.cc;
  var Companion_getInstance_5 = kotlin_kotlin.$_$.w4;
  var _UByteArray___get_size__impl__h6pkdv = kotlin_kotlin.$_$.c3;
  var UByteArray = kotlin_kotlin.$_$.eh;
  var _UByteArray___init__impl__ip4y9n = kotlin_kotlin.$_$.z2;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.u2;
  var UByteArray__get_impl_t5f3hv = kotlin_kotlin.$_$.a3;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.v2;
  var BooleanCompanionObject_getInstance = kotlin_kotlin.$_$.h4;
  var isBooleanArray = kotlin_kotlin.$_$.bc;
  var coerceAtLeast = kotlin_kotlin.$_$.md;
  var copyOf = kotlin_kotlin.$_$.u6;
  var copyOf_0 = kotlin_kotlin.$_$.w6;
  var copyOf_1 = kotlin_kotlin.$_$.x6;
  var copyOf_2 = kotlin_kotlin.$_$.s6;
  var _ULongArray___get_storage__impl__28e64j = kotlin_kotlin.$_$.v3;
  var _ULongArray___init__impl__twm1l3_0 = kotlin_kotlin.$_$.r3;
  var ULongArray__set_impl_z19mvh = kotlin_kotlin.$_$.t3;
  var copyOf_3 = kotlin_kotlin.$_$.z6;
  var _UIntArray___get_storage__impl__92a0v0 = kotlin_kotlin.$_$.m3;
  var _UIntArray___init__impl__ghjpc6_0 = kotlin_kotlin.$_$.i3;
  var UIntArray__set_impl_7f2zu2 = kotlin_kotlin.$_$.k3;
  var copyOf_4 = kotlin_kotlin.$_$.r6;
  var _UShortArray___get_storage__impl__t2jpv5 = kotlin_kotlin.$_$.e4;
  var _UShortArray___init__impl__9b26ef_0 = kotlin_kotlin.$_$.a4;
  var UShortArray__set_impl_6d8whp = kotlin_kotlin.$_$.c4;
  var copyOf_5 = kotlin_kotlin.$_$.v6;
  var _UByteArray___get_storage__impl__d4kctt = kotlin_kotlin.$_$.d3;
  var _UByteArray___init__impl__ip4y9n_0 = kotlin_kotlin.$_$.y2;
  var UByteArray__set_impl_jvcicn = kotlin_kotlin.$_$.b3;
  var copyOf_6 = kotlin_kotlin.$_$.t6;
  var Unit = kotlin_kotlin.$_$.mh;
  var trimIndent = kotlin_kotlin.$_$.fg;
  var equals_0 = kotlin_kotlin.$_$.me;
  var charSequenceLength = kotlin_kotlin.$_$.jb;
  var charSequenceGet = kotlin_kotlin.$_$.ib;
  var toString_0 = kotlin_kotlin.$_$.p2;
  var titlecase = kotlin_kotlin.$_$.nf;
  var isLowerCase = kotlin_kotlin.$_$.qe;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.q4;
  var ULong = kotlin_kotlin.$_$.jh;
  var UInt = kotlin_kotlin.$_$.hh;
  var UShort = kotlin_kotlin.$_$.lh;
  var UByte = kotlin_kotlin.$_$.fh;
  var mapOf = kotlin_kotlin.$_$.n8;
  var lastOrNull = kotlin_kotlin.$_$.e8;
  var get_lastIndex_0 = kotlin_kotlin.$_$.b8;
  var get_js = kotlin_kotlin.$_$.oc;
  var findAssociatedObject = kotlin_kotlin.$_$.c;
  var get_indices = kotlin_kotlin.$_$.w7;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.w1;
  var get_indices_0 = kotlin_kotlin.$_$.v7;
  var Companion_getInstance_6 = kotlin_kotlin.$_$.v4;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.q2;
  var createFailure = kotlin_kotlin.$_$.sh;
  //endregion
  //region block: pre-declaration
  setMetadataFor(SerializationStrategy, 'SerializationStrategy', interfaceMeta);
  setMetadataFor(DeserializationStrategy, 'DeserializationStrategy', interfaceMeta);
  setMetadataFor(KSerializer, 'KSerializer', interfaceMeta, VOID, [SerializationStrategy, DeserializationStrategy]);
  setMetadataFor(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(PolymorphicSerializer, 'PolymorphicSerializer', classMeta, AbstractPolymorphicSerializer);
  setMetadataFor(SealedClassSerializer, 'SealedClassSerializer', classMeta, AbstractPolymorphicSerializer);
  setMetadataFor(SerializationException, 'SerializationException', classMeta, IllegalArgumentException);
  setMetadataFor(UnknownFieldException, 'UnknownFieldException', classMeta, SerializationException);
  setMetadataFor(MissingFieldException, 'MissingFieldException', classMeta, SerializationException);
  function get_isNullable() {
    return false;
  }
  function get_isInline() {
    return false;
  }
  function get_annotations() {
    return emptyList();
  }
  setMetadataFor(SerialDescriptor, 'SerialDescriptor', interfaceMeta);
  setMetadataFor(ContextDescriptor, 'ContextDescriptor', classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(elementDescriptors$1$1, VOID, classMeta);
  setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta, VOID, [Iterable]);
  setMetadataFor(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder', classMeta);
  setMetadataFor(CachedNames, 'CachedNames', interfaceMeta);
  setMetadataFor(SerialDescriptorImpl, 'SerialDescriptorImpl', classMeta, VOID, [SerialDescriptor, CachedNames]);
  setMetadataFor(SerialKind, 'SerialKind', classMeta);
  setMetadataFor(ENUM, 'ENUM', objectMeta, SerialKind);
  setMetadataFor(CONTEXTUAL, 'CONTEXTUAL', objectMeta, SerialKind);
  setMetadataFor(PrimitiveKind, 'PrimitiveKind', classMeta, SerialKind);
  setMetadataFor(BOOLEAN, 'BOOLEAN', objectMeta, PrimitiveKind);
  setMetadataFor(BYTE, 'BYTE', objectMeta, PrimitiveKind);
  setMetadataFor(CHAR, 'CHAR', objectMeta, PrimitiveKind);
  setMetadataFor(SHORT, 'SHORT', objectMeta, PrimitiveKind);
  setMetadataFor(INT, 'INT', objectMeta, PrimitiveKind);
  setMetadataFor(LONG, 'LONG', objectMeta, PrimitiveKind);
  setMetadataFor(FLOAT, 'FLOAT', objectMeta, PrimitiveKind);
  setMetadataFor(DOUBLE, 'DOUBLE', objectMeta, PrimitiveKind);
  setMetadataFor(STRING, 'STRING', objectMeta, PrimitiveKind);
  setMetadataFor(StructureKind, 'StructureKind', classMeta, SerialKind);
  setMetadataFor(CLASS, 'CLASS', objectMeta, StructureKind);
  setMetadataFor(LIST, 'LIST', objectMeta, StructureKind);
  setMetadataFor(MAP, 'MAP', objectMeta, StructureKind);
  setMetadataFor(OBJECT, 'OBJECT', objectMeta, StructureKind);
  setMetadataFor(PolymorphicKind, 'PolymorphicKind', classMeta, SerialKind);
  setMetadataFor(SEALED, 'SEALED', objectMeta, PolymorphicKind);
  setMetadataFor(OPEN, 'OPEN', objectMeta, PolymorphicKind);
  function decodeSerializableValue(deserializer) {
    return deserializer.me8(this);
  }
  setMetadataFor(Decoder, 'Decoder', interfaceMeta);
  function decodeSequentially() {
    return false;
  }
  function decodeCollectionSize(descriptor) {
    return -1;
  }
  function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
    previousValue = previousValue === VOID ? null : previousValue;
    return $super === VOID ? this.seb(descriptor, index, deserializer, previousValue) : $super.seb.call(this, descriptor, index, deserializer, previousValue);
  }
  setMetadataFor(CompositeDecoder, 'CompositeDecoder', interfaceMeta);
  setMetadataFor(AbstractDecoder, 'AbstractDecoder', classMeta, VOID, [Decoder, CompositeDecoder]);
  function encodeNotNullMark() {
  }
  function beginCollection(descriptor, collectionSize) {
    return this.geb(descriptor);
  }
  function encodeSerializableValue(serializer, value) {
    serializer.le8(this, value);
  }
  setMetadataFor(Encoder, 'Encoder', interfaceMeta);
  function shouldEncodeElementDefault(descriptor, index) {
    return true;
  }
  setMetadataFor(CompositeEncoder, 'CompositeEncoder', interfaceMeta);
  setMetadataFor(AbstractEncoder, 'AbstractEncoder', classMeta, VOID, [Encoder, CompositeEncoder]);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(NothingSerializer_0, 'NothingSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(DurationSerializer, 'DurationSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(ListLikeDescriptor, 'ListLikeDescriptor', classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(ArrayListClassDesc, 'ArrayListClassDesc', classMeta, ListLikeDescriptor);
  setMetadataFor(HashSetClassDesc, 'HashSetClassDesc', classMeta, ListLikeDescriptor);
  setMetadataFor(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', classMeta, ListLikeDescriptor);
  setMetadataFor(MapLikeDescriptor, 'MapLikeDescriptor', classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(HashMapClassDesc, 'HashMapClassDesc', classMeta, MapLikeDescriptor);
  setMetadataFor(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', classMeta, MapLikeDescriptor);
  setMetadataFor(ArrayClassDesc, 'ArrayClassDesc', classMeta, ListLikeDescriptor);
  setMetadataFor(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', classMeta, ListLikeDescriptor);
  setMetadataFor(AbstractCollectionSerializer, 'AbstractCollectionSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(CollectionLikeSerializer, 'CollectionLikeSerializer', classMeta, AbstractCollectionSerializer);
  setMetadataFor(CollectionSerializer, 'CollectionSerializer', classMeta, CollectionLikeSerializer);
  setMetadataFor(ArrayListSerializer, 'ArrayListSerializer', classMeta, CollectionSerializer);
  setMetadataFor(HashSetSerializer, 'HashSetSerializer', classMeta, CollectionSerializer);
  setMetadataFor(LinkedHashSetSerializer, 'LinkedHashSetSerializer', classMeta, CollectionSerializer);
  setMetadataFor(MapLikeSerializer, 'MapLikeSerializer', classMeta, AbstractCollectionSerializer);
  setMetadataFor(HashMapSerializer, 'HashMapSerializer', classMeta, MapLikeSerializer);
  setMetadataFor(LinkedHashMapSerializer, 'LinkedHashMapSerializer', classMeta, MapLikeSerializer);
  setMetadataFor(ReferenceArraySerializer, 'ReferenceArraySerializer', classMeta, CollectionLikeSerializer);
  setMetadataFor(PrimitiveArraySerializer, 'PrimitiveArraySerializer', classMeta, CollectionLikeSerializer);
  setMetadataFor(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder', classMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(ElementMarker, 'ElementMarker', classMeta);
  setMetadataFor(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', classMeta, VOID, [SerialDescriptor, CachedNames]);
  setMetadataFor(InlineClassDescriptor, 'InlineClassDescriptor', classMeta, PluginGeneratedSerialDescriptor);
  function typeParametersSerializers() {
    return get_EMPTY_SERIALIZER_ARRAY();
  }
  setMetadataFor(GeneratedSerializer, 'GeneratedSerializer', interfaceMeta, VOID, [KSerializer]);
  setMetadataFor(InlinePrimitiveDescriptor$1, VOID, classMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(NoOpEncoder, 'NoOpEncoder', objectMeta, AbstractEncoder);
  setMetadataFor(NothingSerialDescriptor, 'NothingSerialDescriptor', objectMeta, VOID, [SerialDescriptor]);
  setMetadataFor(NullableSerializer, 'NullableSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(SerialDescriptorForNullable, 'SerialDescriptorForNullable', classMeta, VOID, [SerialDescriptor, CachedNames]);
  setMetadataFor(ObjectSerializer, 'ObjectSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(SerializerFactory, 'SerializerFactory', interfaceMeta);
  setMetadataFor(CharArraySerializer_0, 'CharArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(DoubleArraySerializer_0, 'DoubleArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(FloatArraySerializer_0, 'FloatArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(LongArraySerializer_0, 'LongArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(ULongArraySerializer_0, 'ULongArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(IntArraySerializer_0, 'IntArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(UIntArraySerializer_0, 'UIntArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(ShortArraySerializer_0, 'ShortArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(UShortArraySerializer_0, 'UShortArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(ByteArraySerializer_0, 'ByteArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(UByteArraySerializer_0, 'UByteArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(BooleanArraySerializer_0, 'BooleanArraySerializer', objectMeta, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  setMetadataFor(CharArrayBuilder, 'CharArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(DoubleArrayBuilder, 'DoubleArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(FloatArrayBuilder, 'FloatArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(LongArrayBuilder, 'LongArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(ULongArrayBuilder, 'ULongArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(IntArrayBuilder, 'IntArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(UIntArrayBuilder, 'UIntArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(ShortArrayBuilder, 'ShortArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(UShortArrayBuilder, 'UShortArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(ByteArrayBuilder, 'ByteArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(UByteArrayBuilder, 'UByteArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(BooleanArrayBuilder, 'BooleanArrayBuilder', classMeta, PrimitiveArrayBuilder);
  setMetadataFor(StringSerializer, 'StringSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(CharSerializer, 'CharSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(DoubleSerializer, 'DoubleSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(FloatSerializer, 'FloatSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(LongSerializer, 'LongSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(IntSerializer, 'IntSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(ShortSerializer, 'ShortSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(ByteSerializer, 'ByteSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(BooleanSerializer, 'BooleanSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(UnitSerializer, 'UnitSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(TaggedDecoder, 'TaggedDecoder', classMeta, VOID, [Decoder, CompositeDecoder]);
  setMetadataFor(NamedValueDecoder, 'NamedValueDecoder', classMeta, TaggedDecoder);
  setMetadataFor(MapEntry, 'MapEntry', classMeta, VOID, [Entry]);
  setMetadataFor(KeyValueSerializer, 'KeyValueSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(MapEntrySerializer_0, 'MapEntrySerializer', classMeta, KeyValueSerializer);
  setMetadataFor(PairSerializer_0, 'PairSerializer', classMeta, KeyValueSerializer);
  setMetadataFor(TripleSerializer_0, 'TripleSerializer', classMeta, VOID, [KSerializer]);
  setMetadataFor(ULongSerializer, 'ULongSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(UIntSerializer, 'UIntSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(UShortSerializer, 'UShortSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(UByteSerializer, 'UByteSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(SerializersModule, 'SerializersModule', classMeta);
  setMetadataFor(SerialModuleImpl, 'SerialModuleImpl', classMeta, SerializersModule);
  setMetadataFor(SerializableWith, 'SerializableWith', classMeta, VOID, VOID, 0);
  setMetadataFor(createCache$1, VOID, classMeta);
  setMetadataFor(createParametrizedCache$1, VOID, classMeta);
  //endregion
  function KSerializer() {
  }
  function SerializationStrategy() {
  }
  function DeserializationStrategy() {
  }
  function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.ve8('type', serializer_0(StringCompanionObject_getInstance()).ke8());
      $this$buildSerialDescriptor.ve8('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.we8_1.ue() + '>', CONTEXTUAL_getInstance(), []));
      $this$buildSerialDescriptor.pe8_1 = this$0.xe8_1;
      return Unit_getInstance();
    };
  }
  function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
    return function () {
      var tmp = OPEN_getInstance();
      return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.we8_1);
    };
  }
  function PolymorphicSerializer(baseClass) {
    AbstractPolymorphicSerializer.call(this);
    this.we8_1 = baseClass;
    this.xe8_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ye8_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
  }
  protoOf(PolymorphicSerializer).ze8 = function () {
    return this.we8_1;
  };
  protoOf(PolymorphicSerializer).ke8 = function () {
    // Inline function 'kotlin.getValue' call
    descriptor$factory();
    return this.ye8_1.q();
  };
  protoOf(PolymorphicSerializer).toString = function () {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + this.we8_1 + ')';
  };
  function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.be9(encoder, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.ze8());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
    var tmp0_elvis_lhs = _this__u8e3s4.ae9(decoder, klassName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.ze8());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function descriptor$factory() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.ke8();
    }, null);
  }
  function SealedClassSerializer() {
  }
  function SerializationException_init_$Init$(message, $this) {
    IllegalArgumentException_init_$Init$(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$(message) {
    var tmp = SerializationException_init_$Init$(message, objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function SerializationException_init_$Init$_0(message, cause, $this) {
    IllegalArgumentException_init_$Init$_0(message, cause, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  function UnknownFieldException_init_$Init$(index, $this) {
    UnknownFieldException.call($this, 'An unknown field for index ' + index);
    return $this;
  }
  function UnknownFieldException_init_$Create$(index) {
    var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
    captureStack(tmp, UnknownFieldException_init_$Create$);
    return tmp;
  }
  function UnknownFieldException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, UnknownFieldException);
  }
  function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
    MissingFieldException.call($this, missingFields, missingFields.j() === 1 ? "Field '" + missingFields.k(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + missingFields + " are required for type with serial name '" + serialName + "', but they were missing", null);
    return $this;
  }
  function MissingFieldException_init_$Create$(missingFields, serialName) {
    var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
    captureStack(tmp, MissingFieldException_init_$Create$);
    return tmp;
  }
  function MissingFieldException(missingFields, message, cause) {
    SerializationException_init_$Init$_0(message, cause, this);
    captureStack(this, MissingFieldException);
    this.ce9_1 = missingFields;
  }
  function serializerOrNull(_this__u8e3s4) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
    var tmp;
    if (failOnMissingTypeArgSerializer) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator = typeArguments.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        tmp$ret$0 = serializer(_this__u8e3s4, item);
        tmp0_mapTo.b(tmp$ret$0);
      }
      tmp = tmp0_mapTo;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator_0 = typeArguments.g();
      while (tmp0_iterator_0.h()) {
        var item_0 = tmp0_iterator_0.i();
        var tmp$ret$3;
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$3 = tmp_0;
        tmp0_mapTo_0.b(tmp$ret$3);
      }
      tmp = tmp0_mapTo_0;
    }
    var serializers = tmp;
    return serializers;
  }
  function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
    return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
  }
  function serializer(_this__u8e3s4, type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerOrNull_0(_this__u8e3s4, type) {
    return serializerByKTypeImpl(_this__u8e3s4, type, false);
  }
  function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp;
    if (((_this__u8e3s4.equals(getKClass(Collection)) ? true : _this__u8e3s4.equals(getKClass(List))) ? true : _this__u8e3s4.equals(getKClass(MutableList))) ? true : _this__u8e3s4.equals(getKClass(ArrayList))) {
      tmp = new ArrayListSerializer(serializers.k(0));
    } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
      tmp = new HashSetSerializer(serializers.k(0));
    } else if ((_this__u8e3s4.equals(getKClass(Set)) ? true : _this__u8e3s4.equals(getKClass(MutableSet))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashSet))) {
      tmp = new LinkedHashSetSerializer(serializers.k(0));
    } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
      tmp = new HashMapSerializer(serializers.k(0), serializers.k(1));
    } else if ((_this__u8e3s4.equals(getKClass(Map)) ? true : _this__u8e3s4.equals(getKClass(MutableMap))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashMap))) {
      tmp = new LinkedHashMapSerializer(serializers.k(0), serializers.k(1));
    } else if (_this__u8e3s4.equals(getKClass(Entry))) {
      tmp = MapEntrySerializer(serializers.k(0), serializers.k(1));
    } else if (_this__u8e3s4.equals(getKClass(Pair))) {
      tmp = PairSerializer(serializers.k(0), serializers.k(1));
    } else if (_this__u8e3s4.equals(getKClass(Triple))) {
      tmp = TripleSerializer(serializers.k(0), serializers.k(1), serializers.k(2));
    } else {
      var tmp_0;
      if (isReferenceArray(_this__u8e3s4)) {
        var tmp_1 = elementClassifierIfArray();
        tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.k(0));
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$0 = copyToArray(serializers);
    return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
  }
  function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
    var rootClass = kclass(type);
    var isNullable = type.if();
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = type.hf();
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$2;
      // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        var tmp0_requireNotNull = item.ee9_1;
        // Inline function 'kotlin.contracts.contract' call
        if (tmp0_requireNotNull == null) {
          // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>.<anonymous>' call
          var message = 'Star projections in type arguments are not allowed, but had ' + type;
          throw IllegalArgumentException_init_$Create$(toString(message));
        } else {
          tmp$ret$1 = tmp0_requireNotNull;
          break $l$block;
        }
      }
      tmp$ret$2 = tmp$ret$1;
      tmp0_mapTo.b(tmp$ret$2);
    }
    var typeArguments = tmp0_mapTo;
    var tmp;
    if (typeArguments.l()) {
      tmp = findCachedSerializer(rootClass, isNullable);
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var tmp1_getOrNull = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_0;
      if (_Result___get_isFailure__impl__jpiriv(tmp1_getOrNull)) {
        tmp_0 = null;
      } else {
        var tmp_1 = _Result___get_value__impl__bjfvqg(tmp1_getOrNull);
        tmp_0 = (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE();
      }
      tmp = tmp_0;
    }
    var cachedSerializer = tmp;
    if (cachedSerializer == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return cachedSerializer;
    }
    var tmp_2;
    if (typeArguments.l()) {
      tmp_2 = _this__u8e3s4.ge9(rootClass);
    } else {
      var tmp1_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
      var tmp_3;
      if (tmp1_elvis_lhs == null) {
        return null;
      } else {
        tmp_3 = tmp1_elvis_lhs;
      }
      var serializers = tmp_3;
      var tmp2_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
      tmp_2 = tmp2_elvis_lhs == null ? _this__u8e3s4.fe9(rootClass, serializers) : tmp2_elvis_lhs;
    }
    var contextualSerializer = tmp_2;
    var tmp_4;
    if (contextualSerializer == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_4 = (!(contextualSerializer == null) ? isInterface(contextualSerializer, KSerializer) : false) ? contextualSerializer : THROW_CCE();
    }
    var tmp4_safe_receiver = tmp_4;
    return tmp4_safe_receiver == null ? null : nullable(tmp4_safe_receiver, isNullable);
  }
  function nullable(_this__u8e3s4, shouldBeNullable) {
    if (shouldBeNullable)
      return get_nullable(_this__u8e3s4);
    return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  }
  function serializerByKTypeImpl$lambda($typeArguments) {
    return function () {
      return $typeArguments.k(0).gf();
    };
  }
  function get_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE;
  }
  var SERIALIZERS_CACHE;
  function get_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE_NULLABLE;
  }
  var SERIALIZERS_CACHE_NULLABLE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  function findCachedSerializer(clazz, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp0_safe_receiver = get_SERIALIZERS_CACHE().he9(clazz);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlinx.serialization.internal.cast' call
        tmp_0 = (!(tmp0_safe_receiver == null) ? isInterface(tmp0_safe_receiver, KSerializer) : false) ? tmp0_safe_receiver : THROW_CCE();
      }
      tmp = tmp_0;
    } else {
      tmp = get_SERIALIZERS_CACHE_NULLABLE().he9(clazz);
    }
    return tmp;
  }
  function findParametrizedCachedSerializer(clazz, types, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().ie9(clazz, types);
      tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
    } else {
      tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().ie9(clazz, types);
    }
    return tmp;
  }
  function SERIALIZERS_CACHE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    return serializerOrNull(it);
  }
  function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_safe_receiver = serializerOrNull(it);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = (!(tmp1_safe_receiver == null) ? isInterface(tmp1_safe_receiver, KSerializer) : false) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
    return function () {
      return $types.k(0).gf();
    };
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = (!(tmp1_safe_receiver == null) ? isInterface(tmp1_safe_receiver, KSerializer) : false) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
    return function () {
      return $types.k(0).gf();
    };
  }
  var properties_initialized_SerializersCache_kt_q8kf25;
  function _init_properties_SerializersCache_kt__hgwi2p() {
    if (!properties_initialized_SerializersCache_kt_q8kf25) {
      properties_initialized_SerializersCache_kt_q8kf25 = true;
      SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
      SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
    }
  }
  function get_nullable(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.ke8().je9()) {
      tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this__u8e3s4);
    }
    return tmp;
  }
  function serializer_0(_this__u8e3s4) {
    return StringSerializer_getInstance();
  }
  function serializer_1(_this__u8e3s4) {
    return CharSerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function serializer_2(_this__u8e3s4) {
    return DoubleSerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function serializer_3(_this__u8e3s4) {
    return FloatSerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function serializer_4(_this__u8e3s4) {
    return LongSerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function serializer_5(_this__u8e3s4) {
    return ULongSerializer_getInstance();
  }
  function ULongArraySerializer() {
    return ULongArraySerializer_getInstance();
  }
  function serializer_6(_this__u8e3s4) {
    return IntSerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function serializer_7(_this__u8e3s4) {
    return UIntSerializer_getInstance();
  }
  function UIntArraySerializer() {
    return UIntArraySerializer_getInstance();
  }
  function serializer_8(_this__u8e3s4) {
    return ShortSerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function serializer_9(_this__u8e3s4) {
    return UShortSerializer_getInstance();
  }
  function UShortArraySerializer() {
    return UShortArraySerializer_getInstance();
  }
  function serializer_10(_this__u8e3s4) {
    return ByteSerializer_getInstance();
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function serializer_11(_this__u8e3s4) {
    return UByteSerializer_getInstance();
  }
  function UByteArraySerializer() {
    return UByteArraySerializer_getInstance();
  }
  function serializer_12(_this__u8e3s4) {
    return BooleanSerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function serializer_13(_this__u8e3s4) {
    return UnitSerializer_getInstance();
  }
  function NothingSerializer() {
    return NothingSerializer_getInstance();
  }
  function serializer_14(_this__u8e3s4) {
    return DurationSerializer_getInstance();
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ArraySerializer(kClass, elementSerializer) {
    return new ReferenceArraySerializer(kClass, elementSerializer);
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function ListSerializer(elementSerializer) {
    return new ArrayListSerializer(elementSerializer);
  }
  function withContext(_this__u8e3s4, context) {
    return new ContextDescriptor(_this__u8e3s4, context);
  }
  function ContextDescriptor(original, kClass) {
    this.ke9_1 = original;
    this.le9_1 = kClass;
    this.me9_1 = this.ke9_1.ne9() + '<' + this.le9_1.ue() + '>';
  }
  protoOf(ContextDescriptor).oe9 = function () {
    return this.ke9_1.oe9();
  };
  protoOf(ContextDescriptor).pe9 = function () {
    return this.ke9_1.pe9();
  };
  protoOf(ContextDescriptor).qe9 = function () {
    return this.ke9_1.qe9();
  };
  protoOf(ContextDescriptor).je9 = function () {
    return this.ke9_1.je9();
  };
  protoOf(ContextDescriptor).re9 = function () {
    return this.ke9_1.re9();
  };
  protoOf(ContextDescriptor).se9 = function (index) {
    return this.ke9_1.se9(index);
  };
  protoOf(ContextDescriptor).te9 = function (index) {
    return this.ke9_1.te9(index);
  };
  protoOf(ContextDescriptor).ue9 = function (name) {
    return this.ke9_1.ue9(name);
  };
  protoOf(ContextDescriptor).ve9 = function (index) {
    return this.ke9_1.ve9(index);
  };
  protoOf(ContextDescriptor).we9 = function (index) {
    return this.ke9_1.we9(index);
  };
  protoOf(ContextDescriptor).ne9 = function () {
    return this.me9_1;
  };
  protoOf(ContextDescriptor).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.ke9_1, another.ke9_1) ? another.le9_1.equals(this.le9_1) : false;
  };
  protoOf(ContextDescriptor).hashCode = function () {
    var result = this.le9_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.me9_1) | 0;
    return result;
  };
  protoOf(ContextDescriptor).toString = function () {
    return 'ContextDescriptor(kClass: ' + this.le9_1 + ', original: ' + this.ke9_1 + ')';
  };
  function getContextualDescriptor(_this__u8e3s4, descriptor) {
    var tmp0_safe_receiver = get_capturedKClass(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.descriptors.getContextualDescriptor.<anonymous>' call
      var tmp0_safe_receiver_0 = _this__u8e3s4.ge9(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ke8();
    }
    return tmp;
  }
  function get_capturedKClass(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ContextDescriptor) {
      tmp = _this__u8e3s4.le9_1;
    } else {
      if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
        tmp = get_capturedKClass(_this__u8e3s4.xe9_1);
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function SerialDescriptor() {
  }
  function get_elementDescriptors(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(_this__u8e3s4);
  }
  function elementDescriptors$1$1($this_elementDescriptors) {
    this.bea_1 = $this_elementDescriptors;
    this.aea_1 = $this_elementDescriptors.pe9();
  }
  protoOf(elementDescriptors$1$1).h = function () {
    return this.aea_1 > 0;
  };
  protoOf(elementDescriptors$1$1).i = function () {
    var tmp = this.bea_1.pe9();
    var tmp1 = this.aea_1;
    this.aea_1 = tmp1 - 1 | 0;
    return this.bea_1.te9(tmp - tmp1 | 0);
  };
  function _no_name_provided__qut3iv($this_elementDescriptors) {
    this.cea_1 = $this_elementDescriptors;
  }
  protoOf(_no_name_provided__qut3iv).g = function () {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
    return new elementDescriptors$1$1(this.cea_1);
  };
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp;
    if (builder === VOID) {
      tmp = buildSerialDescriptor$lambda;
    } else {
      tmp = builder;
    }
    builder = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!equals(kind, CLASS_getInstance())) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder.qe8_1.j(), toList(typeParameters), sdBuilder);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this.ne8_1 = serialName;
    this.oe8_1 = false;
    this.pe8_1 = emptyList();
    this.qe8_1 = ArrayList_init_$Create$_0();
    this.re8_1 = HashSet_init_$Create$();
    this.se8_1 = ArrayList_init_$Create$_0();
    this.te8_1 = ArrayList_init_$Create$_0();
    this.ue8_1 = ArrayList_init_$Create$_0();
  }
  protoOf(ClassSerialDescriptorBuilder).dea = function (elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.re8_1.b(elementName)) {
      // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
      var message = "Element with name '" + elementName + "' is already registered in " + this.ne8_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.qe8_1.b(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.se8_1.b(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.te8_1.b(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.ue8_1.b(isOptional);
  };
  protoOf(ClassSerialDescriptorBuilder).ve8 = function (elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.dea(elementName, descriptor, annotations, isOptional);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.dea.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp;
    if (builderAction === VOID) {
      tmp = buildClassSerialDescriptor$lambda;
    } else {
      tmp = builderAction;
    }
    builderAction = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildClassSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.qe8_1.j(), toList(typeParameters), sdBuilder);
  }
  function _get__hashCode__tgwhef($this) {
    // Inline function 'kotlin.getValue' call
    _hashCode$factory();
    return $this.pea_1.q();
  }
  function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.oea_1);
    };
  }
  function SerialDescriptorImpl$toString$lambda(this$0) {
    return function (it) {
      return this$0.ve9(it) + ': ' + this$0.te9(it).ne9();
    };
  }
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this.eea_1 = serialName;
    this.fea_1 = kind;
    this.gea_1 = elementsCount;
    this.hea_1 = builder.pe8_1;
    this.iea_1 = toHashSet(builder.qe8_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp0_toTypedArray = builder.qe8_1;
    tmp.jea_1 = copyToArray(tmp0_toTypedArray);
    this.kea_1 = compactArray(builder.se8_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp0_toTypedArray_0 = builder.te8_1;
    tmp_0.lea_1 = copyToArray(tmp0_toTypedArray_0);
    this.mea_1 = toBooleanArray(builder.ue8_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = withIndex(this.jea_1);
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$2;
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
      tmp$ret$2 = to(item.p3_1, item.o3_1);
      tmp0_mapTo.b(tmp$ret$2);
    }
    tmp_1.nea_1 = toMap(tmp0_mapTo);
    this.oea_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.pea_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  protoOf(SerialDescriptorImpl).ne9 = function () {
    return this.eea_1;
  };
  protoOf(SerialDescriptorImpl).re9 = function () {
    return this.fea_1;
  };
  protoOf(SerialDescriptorImpl).pe9 = function () {
    return this.gea_1;
  };
  protoOf(SerialDescriptorImpl).oe9 = function () {
    return this.hea_1;
  };
  protoOf(SerialDescriptorImpl).qea = function () {
    return this.iea_1;
  };
  protoOf(SerialDescriptorImpl).ve9 = function (index) {
    return getChecked(this.jea_1, index);
  };
  protoOf(SerialDescriptorImpl).ue9 = function (name) {
    var tmp0_elvis_lhs = this.nea_1.c2(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      Companion_getInstance_7();
      tmp = -3;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(SerialDescriptorImpl).se9 = function (index) {
    return getChecked(this.lea_1, index);
  };
  protoOf(SerialDescriptorImpl).te9 = function (index) {
    return getChecked(this.kea_1, index);
  };
  protoOf(SerialDescriptorImpl).we9 = function (index) {
    return getChecked_0(this.mea_1, index);
  };
  protoOf(SerialDescriptorImpl).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ne9() === other.ne9())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
      if (!contentEquals(this.oea_1, other.oea_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.pe9() === other.pe9())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.pe9();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.te9(index).ne9() === other.te9(index).ne9())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.te9(index).re9(), other.te9(index).re9())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SerialDescriptorImpl).hashCode = function () {
    return _get__hashCode__tgwhef(this);
  };
  protoOf(SerialDescriptorImpl).toString = function () {
    var tmp = until(0, this.gea_1);
    var tmp_0 = this.eea_1 + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  };
  function PrimitiveSerialDescriptor(serialName, kind) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.PrimitiveSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return PrimitiveDescriptorSafe(serialName, kind);
  }
  function buildSerialDescriptor$lambda($this$null) {
    return Unit_getInstance();
  }
  function buildClassSerialDescriptor$lambda($this$null) {
    return Unit_getInstance();
  }
  function _hashCode$factory() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef(receiver);
    }, null);
  }
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function SerialKind() {
  }
  protoOf(SerialKind).toString = function () {
    return ensureNotNull(getKClassFromExpression(this).ue());
  };
  protoOf(SerialKind).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function StructureKind() {
    SerialKind.call(this);
  }
  function SEALED() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED();
    return SEALED_instance;
  }
  function OPEN() {
    OPEN_instance = this;
    PolymorphicKind.call(this);
  }
  var OPEN_instance;
  function OPEN_getInstance() {
    if (OPEN_instance == null)
      new OPEN();
    return OPEN_instance;
  }
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  function AbstractDecoder() {
  }
  protoOf(AbstractDecoder).rea = function () {
    throw SerializationException_init_$Create$('' + getKClassFromExpression(this) + " can't retrieve untyped values");
  };
  protoOf(AbstractDecoder).sea = function () {
    return true;
  };
  protoOf(AbstractDecoder).tea = function () {
    return null;
  };
  protoOf(AbstractDecoder).uea = function () {
    var tmp = this.rea();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).vea = function () {
    var tmp = this.rea();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).wea = function () {
    var tmp = this.rea();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).xea = function () {
    var tmp = this.rea();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).yea = function () {
    var tmp = this.rea();
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).zea = function () {
    var tmp = this.rea();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).aeb = function () {
    var tmp = this.rea();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).beb = function () {
    var tmp = this.rea();
    return tmp instanceof Char ? tmp.u7_1 : THROW_CCE();
  };
  protoOf(AbstractDecoder).ceb = function () {
    var tmp = this.rea();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).deb = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).eeb = function (deserializer, previousValue) {
    return this.feb(deserializer);
  };
  protoOf(AbstractDecoder).geb = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).heb = function (descriptor) {
  };
  protoOf(AbstractDecoder).ieb = function (descriptor, index) {
    return this.uea();
  };
  protoOf(AbstractDecoder).jeb = function (descriptor, index) {
    return this.vea();
  };
  protoOf(AbstractDecoder).keb = function (descriptor, index) {
    return this.wea();
  };
  protoOf(AbstractDecoder).leb = function (descriptor, index) {
    return this.xea();
  };
  protoOf(AbstractDecoder).meb = function (descriptor, index) {
    return this.yea();
  };
  protoOf(AbstractDecoder).neb = function (descriptor, index) {
    return this.zea();
  };
  protoOf(AbstractDecoder).oeb = function (descriptor, index) {
    return this.aeb();
  };
  protoOf(AbstractDecoder).peb = function (descriptor, index) {
    return this.beb();
  };
  protoOf(AbstractDecoder).qeb = function (descriptor, index) {
    return this.ceb();
  };
  protoOf(AbstractDecoder).reb = function (descriptor, index) {
    return this.deb(descriptor.te9(index));
  };
  protoOf(AbstractDecoder).seb = function (descriptor, index, deserializer, previousValue) {
    return this.eeb(deserializer, previousValue);
  };
  function AbstractEncoder() {
  }
  protoOf(AbstractEncoder).geb = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).heb = function (descriptor) {
  };
  protoOf(AbstractEncoder).yeb = function (descriptor, index) {
    return true;
  };
  protoOf(AbstractEncoder).zeb = function (value) {
    throw SerializationException_init_$Create$('Non-serializable ' + getKClassFromExpression(value) + ' is not supported by ' + getKClassFromExpression(this) + ' encoder');
  };
  protoOf(AbstractEncoder).aec = function () {
    throw SerializationException_init_$Create$("'null' is not supported by default");
  };
  protoOf(AbstractEncoder).bec = function (value) {
    return this.zeb(value);
  };
  protoOf(AbstractEncoder).cec = function (value) {
    return this.zeb(value);
  };
  protoOf(AbstractEncoder).dec = function (value) {
    return this.zeb(value);
  };
  protoOf(AbstractEncoder).eec = function (value) {
    return this.zeb(value);
  };
  protoOf(AbstractEncoder).fec = function (value) {
    return this.zeb(value);
  };
  protoOf(AbstractEncoder).gec = function (value) {
    return this.zeb(value);
  };
  protoOf(AbstractEncoder).hec = function (value) {
    return this.zeb(value);
  };
  protoOf(AbstractEncoder).iec = function (value) {
    return this.zeb(new Char(value));
  };
  protoOf(AbstractEncoder).jec = function (value) {
    return this.zeb(value);
  };
  protoOf(AbstractEncoder).kec = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).lec = function (descriptor, index, value) {
    if (this.yeb(descriptor, index)) {
      this.bec(value);
    }
  };
  protoOf(AbstractEncoder).mec = function (descriptor, index, value) {
    if (this.yeb(descriptor, index)) {
      this.cec(value);
    }
  };
  protoOf(AbstractEncoder).nec = function (descriptor, index, value) {
    if (this.yeb(descriptor, index)) {
      this.dec(value);
    }
  };
  protoOf(AbstractEncoder).oec = function (descriptor, index, value) {
    if (this.yeb(descriptor, index)) {
      this.eec(value);
    }
  };
  protoOf(AbstractEncoder).pec = function (descriptor, index, value) {
    if (this.yeb(descriptor, index)) {
      this.fec(value);
    }
  };
  protoOf(AbstractEncoder).qec = function (descriptor, index, value) {
    if (this.yeb(descriptor, index)) {
      this.gec(value);
    }
  };
  protoOf(AbstractEncoder).rec = function (descriptor, index, value) {
    if (this.yeb(descriptor, index)) {
      this.hec(value);
    }
  };
  protoOf(AbstractEncoder).sec = function (descriptor, index, value) {
    if (this.yeb(descriptor, index)) {
      this.iec(value);
    }
  };
  protoOf(AbstractEncoder).tec = function (descriptor, index, value) {
    if (this.yeb(descriptor, index)) {
      this.jec(value);
    }
  };
  protoOf(AbstractEncoder).uec = function (descriptor, index) {
    return this.yeb(descriptor, index) ? this.kec(descriptor.te9(index)) : NoOpEncoder_getInstance();
  };
  protoOf(AbstractEncoder).vec = function (descriptor, index, serializer, value) {
    if (this.yeb(descriptor, index)) {
      this.wec(serializer, value);
    }
  };
  function Decoder() {
  }
  function Companion() {
    Companion_instance = this;
    this.aed_1 = -1;
    this.bed_1 = -3;
  }
  var Companion_instance;
  function Companion_getInstance_7() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function CompositeDecoder() {
  }
  function Encoder() {
  }
  function CompositeEncoder() {
  }
  function decodeSequentially_0($this, compositeDecoder) {
    var klassName = compositeDecoder.qeb($this.ke8(), 0);
    var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
    return compositeDecoder.teb($this.ke8(), 1, serializer);
  }
  function AbstractPolymorphicSerializer() {
  }
  protoOf(AbstractPolymorphicSerializer).le8 = function (encoder, value) {
    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var tmp0_encodeStructure = this.ke8();
    var composite = encoder.geb(tmp0_encodeStructure);
    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
    composite.tec(this.ke8(), 0, actualSerializer.ke8().ne9());
    var tmp = this.ke8();
    var tmp$ret$0;
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.vec(tmp, 1, tmp$ret$0, value);
    composite.heb(tmp0_encodeStructure);
  };
  protoOf(AbstractPolymorphicSerializer).me8 = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var tmp0_decodeStructure = this.ke8();
    var composite = decoder.geb(tmp0_decodeStructure);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
      var klassName = null;
      var value = null;
      if (composite.veb()) {
        tmp$ret$0 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.web(this.ke8());
        Companion_getInstance_7();
        if (index === -1) {
          break mainLoop;
        } else {
          if (index === 0) {
            klassName = composite.qeb(this.ke8(), index);
          } else {
            if (index === 1) {
              var tmp$ret$2;
              $l$block_0: {
                // Inline function 'kotlin.requireNotNull' call
                var tmp0_requireNotNull = klassName;
                // Inline function 'kotlin.contracts.contract' call
                if (tmp0_requireNotNull == null) {
                  // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                  var message = 'Cannot read polymorphic value before its type token';
                  throw IllegalArgumentException_init_$Create$(toString(message));
                } else {
                  tmp$ret$2 = tmp0_requireNotNull;
                  break $l$block_0;
                }
              }
              klassName = tmp$ret$2;
              var serializer = findPolymorphicSerializer_0(this, composite, klassName);
              value = composite.teb(this.ke8(), index, serializer);
            } else {
              var tmp0_elvis_lhs = klassName;
              throw SerializationException_init_$Create$('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
            }
          }
        }
      }
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        var tmp1_requireNotNull = value;
        // Inline function 'kotlin.contracts.contract' call
        if (tmp1_requireNotNull == null) {
          // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException_init_$Create$(toString(message_0));
        } else {
          tmp$ret$4 = tmp1_requireNotNull;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$0 = isObject(tmp) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$0;
    composite.heb(tmp0_decodeStructure);
    return result;
  };
  protoOf(AbstractPolymorphicSerializer).ae9 = function (decoder, klassName) {
    return decoder.ueb().ced(this.ze8(), klassName);
  };
  protoOf(AbstractPolymorphicSerializer).be9 = function (encoder, value) {
    return encoder.ueb().ded(this.ze8(), value);
  };
  function throwSubtypeNotRegistered(subClass, baseClass) {
    var tmp0_elvis_lhs = subClass.ue();
    throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? '' + subClass : tmp0_elvis_lhs, baseClass);
  }
  function throwSubtypeNotRegistered_0(subClassName, baseClass) {
    var scope = "in the scope of '" + baseClass.ue() + "'";
    throw SerializationException_init_$Create$(subClassName == null ? 'Class discriminator was missing and no default polymorphic serializers were registered ' + scope : "Class '" + subClassName + "' is not registered for polymorphic serialization " + scope + '.\n' + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.ue() + "' has to be sealed and '@Serializable'.\n") + ("Alternatively, register the serializer for '" + subClassName + "' explicitly in a corresponding SerializersModule."));
  }
  function NothingSerializer_0() {
    NothingSerializer_instance = this;
    this.eed_1 = NothingSerialDescriptor_getInstance();
  }
  protoOf(NothingSerializer_0).ke8 = function () {
    return this.eed_1;
  };
  protoOf(NothingSerializer_0).fed = function (encoder, value) {
    throw SerializationException_init_$Create$("'kotlin.Nothing' cannot be serialized");
  };
  protoOf(NothingSerializer_0).le8 = function (encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.fed(encoder, tmp);
  };
  protoOf(NothingSerializer_0).me8 = function (decoder) {
    throw SerializationException_init_$Create$("'kotlin.Nothing' does not have instances");
  };
  var NothingSerializer_instance;
  function NothingSerializer_getInstance() {
    if (NothingSerializer_instance == null)
      new NothingSerializer_0();
    return NothingSerializer_instance;
  }
  function DurationSerializer() {
    DurationSerializer_instance = this;
    this.ged_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
  }
  protoOf(DurationSerializer).ke8 = function () {
    return this.ged_1;
  };
  protoOf(DurationSerializer).hed = function (encoder, value) {
    encoder.jec(Duration__toIsoString_impl_9h6wsm(value));
  };
  protoOf(DurationSerializer).le8 = function (encoder, value) {
    return this.hed(encoder, value instanceof Duration ? value.n8_1 : THROW_CCE());
  };
  protoOf(DurationSerializer).ied = function (decoder) {
    return Companion_getInstance().m8(decoder.ceb());
  };
  protoOf(DurationSerializer).me8 = function (decoder) {
    return new Duration(this.ied(decoder));
  };
  var DurationSerializer_instance;
  function DurationSerializer_getInstance() {
    if (DurationSerializer_instance == null)
      new DurationSerializer();
    return DurationSerializer_instance;
  }
  function CachedNames() {
  }
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayListClassDesc).ne9 = function () {
    return 'kotlin.collections.ArrayList';
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(HashSetClassDesc).ne9 = function () {
    return 'kotlin.collections.HashSet';
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(LinkedHashSetClassDesc).ne9 = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayClassDesc).ne9 = function () {
    return 'kotlin.Array';
  };
  function ListLikeDescriptor(elementDescriptor) {
    this.led_1 = elementDescriptor;
    this.med_1 = 1;
  }
  protoOf(ListLikeDescriptor).re9 = function () {
    return LIST_getInstance();
  };
  protoOf(ListLikeDescriptor).pe9 = function () {
    return this.med_1;
  };
  protoOf(ListLikeDescriptor).ve9 = function (index) {
    return index.toString();
  };
  protoOf(ListLikeDescriptor).ue9 = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ListLikeDescriptor).we9 = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ne9() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(ListLikeDescriptor).se9 = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ne9() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(ListLikeDescriptor).te9 = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ne9() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.led_1;
  };
  protoOf(ListLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.led_1, other.led_1) ? this.ne9() === other.ne9() : false)
      return true;
    return false;
  };
  protoOf(ListLikeDescriptor).hashCode = function () {
    return imul(hashCode(this.led_1), 31) + getStringHashCode(this.ne9()) | 0;
  };
  protoOf(ListLikeDescriptor).toString = function () {
    return this.ne9() + '(' + this.led_1 + ')';
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this.red_1 = serialName;
    this.sed_1 = keyDescriptor;
    this.ted_1 = valueDescriptor;
    this.ued_1 = 2;
  }
  protoOf(MapLikeDescriptor).ne9 = function () {
    return this.red_1;
  };
  protoOf(MapLikeDescriptor).re9 = function () {
    return MAP_getInstance();
  };
  protoOf(MapLikeDescriptor).pe9 = function () {
    return this.ued_1;
  };
  protoOf(MapLikeDescriptor).ve9 = function (index) {
    return index.toString();
  };
  protoOf(MapLikeDescriptor).ue9 = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).we9 = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ne9() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(MapLikeDescriptor).se9 = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ne9() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(MapLikeDescriptor).te9 = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ne9() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.sed_1;
        break;
      case 1:
        tmp = this.ted_1;
        break;
      default:
        throw IllegalStateException_init_$Create$('Unreached');
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.ne9() === other.ne9()))
      return false;
    if (!equals(this.sed_1, other.sed_1))
      return false;
    if (!equals(this.ted_1, other.ted_1))
      return false;
    return true;
  };
  protoOf(MapLikeDescriptor).hashCode = function () {
    var result = getStringHashCode(this.ne9());
    result = imul(31, result) + hashCode(this.sed_1) | 0;
    result = imul(31, result) + hashCode(this.ted_1) | 0;
    return result;
  };
  protoOf(MapLikeDescriptor).toString = function () {
    return this.ne9() + '(' + this.sed_1 + ', ' + this.ted_1 + ')';
  };
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this.zed_1 = primitive.ne9() + 'Array';
  }
  protoOf(PrimitiveArrayDescriptor).ne9 = function () {
    return this.zed_1;
  };
  function ArrayListSerializer(element) {
    CollectionSerializer.call(this, element);
    this.bee_1 = new ArrayListClassDesc(element.ke8());
  }
  protoOf(ArrayListSerializer).ke8 = function () {
    return this.bee_1;
  };
  protoOf(ArrayListSerializer).cee = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ArrayListSerializer).dee = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(ArrayListSerializer).eee = function (_this__u8e3s4) {
    return this.dee(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).fee = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(ArrayListSerializer).gee = function (_this__u8e3s4) {
    return this.fee(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).hee = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(ArrayListSerializer).iee = function (_this__u8e3s4) {
    return this.hee((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, List) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).jee = function (_this__u8e3s4, size) {
    return _this__u8e3s4.hc(size);
  };
  protoOf(ArrayListSerializer).kee = function (_this__u8e3s4, size) {
    return this.jee(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ArrayListSerializer).lee = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.u2(index, element);
  };
  protoOf(ArrayListSerializer).mee = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.lee(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  function HashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.xee_1 = new HashSetClassDesc(eSerializer.ke8());
  }
  protoOf(HashSetSerializer).ke8 = function () {
    return this.xee_1;
  };
  protoOf(HashSetSerializer).cee = function () {
    return HashSet_init_$Create$();
  };
  protoOf(HashSetSerializer).yee = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(HashSetSerializer).eee = function (_this__u8e3s4) {
    return this.yee(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).zee = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashSetSerializer).gee = function (_this__u8e3s4) {
    return this.zee(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).aef = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashSetSerializer).iee = function (_this__u8e3s4) {
    return this.aef((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Set) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).bef = function (_this__u8e3s4, size) {
  };
  protoOf(HashSetSerializer).kee = function (_this__u8e3s4, size) {
    return this.bef(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(HashSetSerializer).cef = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.b(element);
  };
  protoOf(HashSetSerializer).mee = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
    return this.cef(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  function LinkedHashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.eef_1 = new LinkedHashSetClassDesc(eSerializer.ke8());
  }
  protoOf(LinkedHashSetSerializer).ke8 = function () {
    return this.eef_1;
  };
  protoOf(LinkedHashSetSerializer).cee = function () {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet_init_$Create$();
  };
  protoOf(LinkedHashSetSerializer).fef = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(LinkedHashSetSerializer).eee = function (_this__u8e3s4) {
    return this.fef(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).gef = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashSetSerializer).gee = function (_this__u8e3s4) {
    return this.gef(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).aef = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashSetSerializer).iee = function (_this__u8e3s4) {
    return this.aef((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Set) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).hef = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashSetSerializer).kee = function (_this__u8e3s4, size) {
    return this.hef(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(LinkedHashSetSerializer).ief = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.b(element);
  };
  protoOf(LinkedHashSetSerializer).mee = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
    return this.ief(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.lef_1 = new HashMapClassDesc(kSerializer.ke8(), vSerializer.ke8());
  }
  protoOf(HashMapSerializer).ke8 = function () {
    return this.lef_1;
  };
  protoOf(HashMapSerializer).mef = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(HashMapSerializer).nef = function (_this__u8e3s4) {
    return this.mef((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).oef = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.o().g();
  };
  protoOf(HashMapSerializer).pef = function (_this__u8e3s4) {
    return this.oef((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).cee = function () {
    return HashMap_init_$Create$();
  };
  protoOf(HashMapSerializer).qef = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.j(), 2);
  };
  protoOf(HashMapSerializer).eee = function (_this__u8e3s4) {
    return this.qef(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).ref = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashMapSerializer).gee = function (_this__u8e3s4) {
    return this.ref(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).sef = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashMapSerializer).iee = function (_this__u8e3s4) {
    return this.sef((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).tef = function (_this__u8e3s4, size) {
  };
  protoOf(HashMapSerializer).kee = function (_this__u8e3s4, size) {
    return this.tef(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.yef_1 = new LinkedHashMapClassDesc(kSerializer.ke8(), vSerializer.ke8());
  }
  protoOf(LinkedHashMapSerializer).ke8 = function () {
    return this.yef_1;
  };
  protoOf(LinkedHashMapSerializer).mef = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(LinkedHashMapSerializer).nef = function (_this__u8e3s4) {
    return this.mef((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).oef = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.o().g();
  };
  protoOf(LinkedHashMapSerializer).pef = function (_this__u8e3s4) {
    return this.oef((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).cee = function () {
    return LinkedHashMap_init_$Create$();
  };
  protoOf(LinkedHashMapSerializer).zef = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.j(), 2);
  };
  protoOf(LinkedHashMapSerializer).eee = function (_this__u8e3s4) {
    return this.zef(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).aeg = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashMapSerializer).gee = function (_this__u8e3s4) {
    return this.aeg(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).sef = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashMapSerializer).iee = function (_this__u8e3s4) {
    return this.sef((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Map) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).beg = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashMapSerializer).kee = function (_this__u8e3s4, size) {
    return this.beg(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    CollectionLikeSerializer.call(this, eSerializer);
    this.deg_1 = kClass;
    this.eeg_1 = new ArrayClassDesc(eSerializer.ke8());
  }
  protoOf(ReferenceArraySerializer).ke8 = function () {
    return this.eeg_1;
  };
  protoOf(ReferenceArraySerializer).feg = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ReferenceArraySerializer).nef = function (_this__u8e3s4) {
    return this.feg((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).geg = function (_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  };
  protoOf(ReferenceArraySerializer).pef = function (_this__u8e3s4) {
    return this.geg((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).cee = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ReferenceArraySerializer).heg = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(ReferenceArraySerializer).eee = function (_this__u8e3s4) {
    return this.heg(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).ieg = function (_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.deg_1);
  };
  protoOf(ReferenceArraySerializer).gee = function (_this__u8e3s4) {
    return this.ieg(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).jeg = function (_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
  };
  protoOf(ReferenceArraySerializer).iee = function (_this__u8e3s4) {
    return this.jeg((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).keg = function (_this__u8e3s4, size) {
    return _this__u8e3s4.hc(size);
  };
  protoOf(ReferenceArraySerializer).kee = function (_this__u8e3s4, size) {
    return this.keg(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ReferenceArraySerializer).leg = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.u2(index, element);
  };
  protoOf(ReferenceArraySerializer).mee = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.leg(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  function CollectionSerializer(element) {
    CollectionLikeSerializer.call(this, element);
  }
  protoOf(CollectionSerializer).oee = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(CollectionSerializer).nef = function (_this__u8e3s4) {
    return this.oee((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CollectionSerializer).pee = function (_this__u8e3s4) {
    return _this__u8e3s4.g();
  };
  protoOf(CollectionSerializer).pef = function (_this__u8e3s4) {
    return this.pee((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this.uef_1 = keySerializer;
    this.vef_1 = valueSerializer;
  }
  protoOf(MapLikeSerializer).see = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.a1_1;
    var last = progression.b1_1;
    var step_0 = progression.c1_1;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.tee(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  };
  protoOf(MapLikeSerializer).tee = function (decoder, index, builder, checkIndex) {
    var key = decoder.teb(this.ke8(), index, this.uef_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var tmp0_also = decoder.web(this.ke8());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(tmp0_also === (index + 1 | 0))) {
        // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>.<anonymous>' call
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + tmp0_also;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      tmp = tmp0_also;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.w1(key)) {
      var tmp_2 = this.vef_1.ke8().re9();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.seb(this.ke8(), vIndex, this.vef_1, getValue(builder, key));
    } else {
      tmp_0 = decoder.teb(this.ke8(), vIndex, this.vef_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.g4(key, value);
  };
  protoOf(MapLikeSerializer).ree = function (encoder, value) {
    var size = this.nef(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var tmp0_encodeCollection = this.ke8();
    var composite = encoder.yec(tmp0_encodeCollection, size);
    // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>' call
    var iterator = this.pef(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = iterator;
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.p();
      // Inline function 'kotlin.collections.component2' call
      var v = element.q();
      var tmp = this.ke8();
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      composite.vec(tmp, tmp0, this.uef_1, k);
      var tmp_0 = this.ke8();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      composite.vec(tmp_0, tmp1, this.vef_1, v);
    }
    composite.heb(tmp0_encodeCollection);
  };
  protoOf(MapLikeSerializer).le8 = function (encoder, value) {
    return this.ree(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  function CollectionLikeSerializer(elementSerializer) {
    AbstractCollectionSerializer.call(this);
    this.qee_1 = elementSerializer;
  }
  protoOf(CollectionLikeSerializer).ree = function (encoder, value) {
    var size = this.nef(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var tmp0_encodeCollection = this.ke8();
    var composite = encoder.yec(tmp0_encodeCollection, size);
    // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
    var iterator = this.pef(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.vec(this.ke8(), index, this.qee_1, iterator.i());
      }
       while (inductionVariable < size);
    composite.heb(tmp0_encodeCollection);
  };
  protoOf(CollectionLikeSerializer).le8 = function (encoder, value) {
    return this.ree(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  protoOf(CollectionLikeSerializer).see = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.tee(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  };
  protoOf(CollectionLikeSerializer).tee = function (decoder, index, builder, checkIndex) {
    this.mee(builder, index, decoder.teb(this.ke8(), index, this.qee_1));
  };
  function readSize($this, decoder, builder) {
    var size = decoder.xeb($this.ke8());
    $this.kee(builder, size);
    return size;
  }
  function AbstractCollectionSerializer() {
  }
  protoOf(AbstractCollectionSerializer).vee = function (decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.iee(previous);
    var builder = tmp1_elvis_lhs == null ? this.cee() : tmp1_elvis_lhs;
    var startIndex = this.eee(builder);
    var compositeDecoder = decoder.geb(this.ke8());
    if (compositeDecoder.veb()) {
      this.see(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.web(this.ke8());
        Companion_getInstance_7();
        if (index === -1)
          break $l$loop;
        this.uee(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.heb(this.ke8());
    return this.gee(builder);
  };
  protoOf(AbstractCollectionSerializer).me8 = function (decoder) {
    return this.vee(decoder, null);
  };
  protoOf(AbstractCollectionSerializer).uee = function (decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.tee(decoder, index, builder, checkIndex);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.tee.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    CollectionLikeSerializer.call(this, primitiveSerializer);
    this.neg_1 = new PrimitiveArrayDescriptor(primitiveSerializer.ke8());
  }
  protoOf(PrimitiveArraySerializer).ke8 = function () {
    return this.neg_1;
  };
  protoOf(PrimitiveArraySerializer).eee = function (_this__u8e3s4) {
    return _this__u8e3s4.b39();
  };
  protoOf(PrimitiveArraySerializer).gee = function (_this__u8e3s4) {
    return _this__u8e3s4.gc();
  };
  protoOf(PrimitiveArraySerializer).kee = function (_this__u8e3s4, size) {
    return _this__u8e3s4.hc(size);
  };
  protoOf(PrimitiveArraySerializer).oeg = function (_this__u8e3s4) {
    throw IllegalStateException_init_$Create$('This method lead to boxing and must not be used, use writeContents instead');
  };
  protoOf(PrimitiveArraySerializer).pef = function (_this__u8e3s4) {
    return this.oeg((_this__u8e3s4 == null ? true : isObject(_this__u8e3s4)) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).mee = function (_this__u8e3s4, index, element) {
    throw IllegalStateException_init_$Create$('This method lead to boxing and must not be used, use Builder.append instead');
  };
  protoOf(PrimitiveArraySerializer).cee = function () {
    return this.iee(this.peg());
  };
  protoOf(PrimitiveArraySerializer).reg = function (encoder, value) {
    var size = this.nef(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var tmp0_encodeCollection = this.neg_1;
    var composite = encoder.yec(tmp0_encodeCollection, size);
    // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
    this.qeg(composite, value, size);
    composite.heb(tmp0_encodeCollection);
  };
  protoOf(PrimitiveArraySerializer).le8 = function (encoder, value) {
    return this.reg(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).ree = function (encoder, value) {
    return this.reg(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).me8 = function (decoder) {
    return this.vee(decoder, null);
  };
  function PrimitiveArrayBuilder() {
  }
  protoOf(PrimitiveArrayBuilder).seg = function (requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.b39() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.hc(requiredCapacity);
      tmp = Unit_getInstance();
    } else {
      tmp = $super.hc.call(this, requiredCapacity);
    }
    return tmp;
  };
  function Companion_0() {
    Companion_instance_0 = this;
    this.teg_1 = longArray(0);
  }
  var Companion_instance_0;
  function Companion_getInstance_8() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function prepareHighMarksArray($this, elementsCount) {
    var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
    Companion_getInstance_0();
    var elementsInLastSlot = elementsCount & (64 - 1 | 0);
    var highMarks = longArray(slotsCount);
    if (!(elementsInLastSlot === 0)) {
      highMarks[get_lastIndex(highMarks)] = (new Long(-1, -1)).u8(elementsCount);
    }
    return highMarks;
  }
  function markHigh($this, index) {
    var slot = (index >>> 6 | 0) - 1 | 0;
    Companion_getInstance_0();
    var offsetInSlot = index & (64 - 1 | 0);
    $this.xeg_1[slot] = $this.xeg_1[slot].mi((new Long(1, 0)).u8(offsetInSlot));
  }
  function nextUnmarkedHighIndex($this) {
    var inductionVariable = 0;
    var last = $this.xeg_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var slot = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = slot + 1 | 0;
        Companion_getInstance_0();
        var slotOffset = imul(tmp, 64);
        var slotMarks = $this.xeg_1[slot];
        while (!slotMarks.equals(new Long(-1, -1))) {
          var indexInSlot = countTrailingZeroBits(slotMarks.li());
          slotMarks = slotMarks.mi((new Long(1, 0)).u8(indexInSlot));
          var index = slotOffset + indexInSlot | 0;
          if ($this.veg_1($this.ueg_1, index)) {
            $this.xeg_1[slot] = slotMarks;
            return index;
          }
        }
        $this.xeg_1[slot] = slotMarks;
      }
       while (inductionVariable <= last);
    Companion_getInstance_7();
    return -1;
  }
  function ElementMarker(descriptor, readIfAbsent) {
    Companion_getInstance_8();
    this.ueg_1 = descriptor;
    this.veg_1 = readIfAbsent;
    var elementsCount = this.ueg_1.pe9();
    Companion_getInstance_0();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      Companion_getInstance_0();
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = (new Long(-1, -1)).u8(elementsCount);
      }
      tmp.weg_1 = tmp_0;
      this.xeg_1 = Companion_getInstance_8().teg_1;
    } else {
      this.weg_1 = new Long(0, 0);
      this.xeg_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  protoOf(ElementMarker).yeg = function (index) {
    Companion_getInstance_0();
    if (index < 64) {
      this.weg_1 = this.weg_1.mi((new Long(1, 0)).u8(index));
    } else {
      markHigh(this, index);
    }
  };
  protoOf(ElementMarker).zeg = function () {
    var elementsCount = this.ueg_1.pe9();
    while (!this.weg_1.equals(new Long(-1, -1))) {
      var index = countTrailingZeroBits(this.weg_1.li());
      this.weg_1 = this.weg_1.mi((new Long(1, 0)).u8(index));
      if (this.veg_1(this.ueg_1, index)) {
        return index;
      }
    }
    Companion_getInstance_0();
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    Companion_getInstance_7();
    return -1;
  };
  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
    return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
  }
  function InlineClassDescriptor(name, generatedSerializer) {
    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
    this.meh_1 = true;
  }
  protoOf(InlineClassDescriptor).qe9 = function () {
    return this.meh_1;
  };
  protoOf(InlineClassDescriptor).hashCode = function () {
    return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
  };
  protoOf(InlineClassDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ne9() === other.ne9())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.InlineClassDescriptor.equals.<anonymous>' call
      if (!(other.meh_1 ? contentEquals(this.zeh(), other.zeh()) : false)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.pe9() === other.pe9())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.pe9();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.te9(index).ne9() === other.te9(index).ne9())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.te9(index).re9(), other.te9(index).re9())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function InlinePrimitiveDescriptor$1($primitiveSerializer) {
    this.bei_1 = $primitiveSerializer;
  }
  protoOf(InlinePrimitiveDescriptor$1).cei = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.bei_1];
  };
  protoOf(InlinePrimitiveDescriptor$1).ke8 = function () {
    throw IllegalStateException_init_$Create$('unsupported');
  };
  protoOf(InlinePrimitiveDescriptor$1).le8 = function (encoder, value) {
    // Inline function 'kotlin.error' call
    throw IllegalStateException_init_$Create$('unsupported');
  };
  protoOf(InlinePrimitiveDescriptor$1).me8 = function (decoder) {
    // Inline function 'kotlin.error' call
    throw IllegalStateException_init_$Create$('unsupported');
  };
  function jsonCachedSerialNames(_this__u8e3s4) {
    return cachedSerialNames(_this__u8e3s4);
  }
  function NoOpEncoder() {
    NoOpEncoder_instance = this;
    AbstractEncoder.call(this);
    this.eei_1 = EmptySerializersModule_0();
  }
  protoOf(NoOpEncoder).ueb = function () {
    return this.eei_1;
  };
  protoOf(NoOpEncoder).zeb = function (value) {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).aec = function () {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).bec = function (value) {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).cec = function (value) {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).dec = function (value) {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).eec = function (value) {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).fec = function (value) {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).gec = function (value) {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).hec = function (value) {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).iec = function (value) {
    return Unit_getInstance();
  };
  protoOf(NoOpEncoder).jec = function (value) {
    return Unit_getInstance();
  };
  var NoOpEncoder_instance;
  function NoOpEncoder_getInstance() {
    if (NoOpEncoder_instance == null)
      new NoOpEncoder();
    return NoOpEncoder_instance;
  }
  function error($this) {
    throw IllegalStateException_init_$Create$('Descriptor for type `kotlin.Nothing` does not have elements');
  }
  function NothingSerialDescriptor() {
    NothingSerialDescriptor_instance = this;
    this.fei_1 = OBJECT_getInstance();
    this.gei_1 = 'kotlin.Nothing';
  }
  protoOf(NothingSerialDescriptor).re9 = function () {
    return this.fei_1;
  };
  protoOf(NothingSerialDescriptor).ne9 = function () {
    return this.gei_1;
  };
  protoOf(NothingSerialDescriptor).pe9 = function () {
    return 0;
  };
  protoOf(NothingSerialDescriptor).ve9 = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).ue9 = function (name) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).we9 = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).te9 = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).se9 = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).toString = function () {
    return 'NothingSerialDescriptor';
  };
  protoOf(NothingSerialDescriptor).equals = function (other) {
    return this === other;
  };
  protoOf(NothingSerialDescriptor).hashCode = function () {
    return getStringHashCode(this.gei_1) + imul(31, this.fei_1.hashCode()) | 0;
  };
  var NothingSerialDescriptor_instance;
  function NothingSerialDescriptor_getInstance() {
    if (NothingSerialDescriptor_instance == null)
      new NothingSerialDescriptor();
    return NothingSerialDescriptor_instance;
  }
  function NullableSerializer(serializer) {
    this.hei_1 = serializer;
    this.iei_1 = new SerialDescriptorForNullable(this.hei_1.ke8());
  }
  protoOf(NullableSerializer).ke8 = function () {
    return this.iei_1;
  };
  protoOf(NullableSerializer).jei = function (encoder, value) {
    if (!(value == null)) {
      encoder.xec();
      encoder.wec(this.hei_1, value);
    } else {
      encoder.aec();
    }
  };
  protoOf(NullableSerializer).le8 = function (encoder, value) {
    return this.jei(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  protoOf(NullableSerializer).me8 = function (decoder) {
    return decoder.sea() ? decoder.feb(this.hei_1) : decoder.tea();
  };
  protoOf(NullableSerializer).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.hei_1, other.hei_1))
      return false;
    return true;
  };
  protoOf(NullableSerializer).hashCode = function () {
    return hashCode(this.hei_1);
  };
  function SerialDescriptorForNullable(original) {
    this.xe9_1 = original;
    this.ye9_1 = this.xe9_1.ne9() + '?';
    this.ze9_1 = cachedSerialNames(this.xe9_1);
  }
  protoOf(SerialDescriptorForNullable).oe9 = function () {
    return this.xe9_1.oe9();
  };
  protoOf(SerialDescriptorForNullable).pe9 = function () {
    return this.xe9_1.pe9();
  };
  protoOf(SerialDescriptorForNullable).qe9 = function () {
    return this.xe9_1.qe9();
  };
  protoOf(SerialDescriptorForNullable).re9 = function () {
    return this.xe9_1.re9();
  };
  protoOf(SerialDescriptorForNullable).se9 = function (index) {
    return this.xe9_1.se9(index);
  };
  protoOf(SerialDescriptorForNullable).te9 = function (index) {
    return this.xe9_1.te9(index);
  };
  protoOf(SerialDescriptorForNullable).ue9 = function (name) {
    return this.xe9_1.ue9(name);
  };
  protoOf(SerialDescriptorForNullable).ve9 = function (index) {
    return this.xe9_1.ve9(index);
  };
  protoOf(SerialDescriptorForNullable).we9 = function (index) {
    return this.xe9_1.we9(index);
  };
  protoOf(SerialDescriptorForNullable).ne9 = function () {
    return this.ye9_1;
  };
  protoOf(SerialDescriptorForNullable).qea = function () {
    return this.ze9_1;
  };
  protoOf(SerialDescriptorForNullable).je9 = function () {
    return true;
  };
  protoOf(SerialDescriptorForNullable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.xe9_1, other.xe9_1))
      return false;
    return true;
  };
  protoOf(SerialDescriptorForNullable).toString = function () {
    return '' + this.xe9_1 + '?';
  };
  protoOf(SerialDescriptorForNullable).hashCode = function () {
    return imul(hashCode(this.xe9_1), 31);
  };
  function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.pe8_1 = this$0.lei_1;
      return Unit_getInstance();
    };
  }
  function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = OBJECT_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function ObjectSerializer(serialName, objectInstance) {
    this.kei_1 = objectInstance;
    this.lei_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.mei_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
  }
  protoOf(ObjectSerializer).ke8 = function () {
    // Inline function 'kotlin.getValue' call
    descriptor$factory_0();
    return this.mei_1.q();
  };
  protoOf(ObjectSerializer).le8 = function (encoder, value) {
    encoder.geb(this.ke8()).heb(this.ke8());
  };
  protoOf(ObjectSerializer).me8 = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var tmp0_decodeStructure = this.ke8();
    var composite = decoder.geb(tmp0_decodeStructure);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.internal.ObjectSerializer.deserialize.<anonymous>' call
      if (composite.veb()) {
        tmp$ret$0 = Unit_getInstance();
        break $l$block_0;
      }
      var index = composite.web(this.ke8());
      Companion_getInstance_7();
      if (index === -1) {
        tmp$ret$0 = Unit_getInstance();
        break $l$block_0;
      } else {
        throw SerializationException_init_$Create$('Unexpected index ' + index);
      }
    }
    var result = tmp$ret$0;
    composite.heb(tmp0_decodeStructure);
    return this.kei_1;
  };
  function descriptor$factory_0() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.ke8();
    }, null);
  }
  function get_EMPTY_DESCRIPTOR_ARRAY() {
    _init_properties_Platform_common_kt__3qzecs();
    return EMPTY_DESCRIPTOR_ARRAY;
  }
  var EMPTY_DESCRIPTOR_ARRAY;
  function cachedSerialNames(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    if (isInterface(_this__u8e3s4, CachedNames))
      return _this__u8e3s4.qea();
    var result = HashSet_init_$Create$_1(_this__u8e3s4.pe9());
    var inductionVariable = 0;
    var last = _this__u8e3s4.pe9();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        var tmp0_plusAssign = _this__u8e3s4.ve9(i);
        result.b(tmp0_plusAssign);
      }
       while (inductionVariable < last);
    return result;
  }
  function kclass(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var t = _this__u8e3s4.gf();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
        var tmp0_error = 'Captured type parameter ' + t + ' from generic non-reified function. ' + ('Such functionality cannot be supported as ' + t + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + t);
        throw IllegalStateException_init_$Create$(toString(tmp0_error));
      } else {
        var tmp1_error = 'Only KClass supported as classifier, got ' + t;
        throw IllegalStateException_init_$Create$(toString(tmp1_error));
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function notRegisteredMessage(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0_elvis_lhs = _this__u8e3s4.ue();
    return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
  }
  function notRegisteredMessage_0(className) {
    _init_properties_Platform_common_kt__3qzecs();
    return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
  }
  function compactArray(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    // Inline function 'kotlin.takeUnless' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(_this__u8e3s4 == null ? true : _this__u8e3s4.l())) {
      tmp = _this__u8e3s4;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
  }
  var properties_initialized_Platform_common_kt_i7q4ty;
  function _init_properties_Platform_common_kt__3qzecs() {
    if (!properties_initialized_Platform_common_kt_i7q4ty) {
      properties_initialized_Platform_common_kt_i7q4ty = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_DESCRIPTOR_ARRAY = [];
    }
  }
  function throwMissingFieldException(seen, goldenMask, descriptor) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var missingFields = ArrayList_init_$Create$_0();
    var missingFieldsBits = goldenMask & ~seen;
    var inductionVariable = 0;
    if (inductionVariable < 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!((missingFieldsBits & 1) === 0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          var tmp0_plusAssign = descriptor.ve9(i);
          missingFields.b(tmp0_plusAssign);
        }
        missingFieldsBits = missingFieldsBits >>> 1 | 0;
      }
       while (inductionVariable < 32);
    throw MissingFieldException_init_$Create$(missingFields, descriptor.ne9());
  }
  function _get_childSerializers__7vnyfa($this) {
    // Inline function 'kotlin.getValue' call
    childSerializers$factory();
    return $this.weh_1.q();
  }
  function _get__hashCode__tgwhef_0($this) {
    // Inline function 'kotlin.getValue' call
    _hashCode$factory_0();
    return $this.yeh_1.q();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last = $this.reh_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var tmp0_set = $this.reh_1[i];
        indices.g4(tmp0_set, i);
      }
       while (inductionVariable <= last);
    return indices;
  }
  function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.oeh_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cei();
      return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
    };
  }
  function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.oeh_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dei();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$2;
        // Inline function 'kotlin.collections.map' call
        var tmp$ret$1;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo = ArrayList_init_$Create$(tmp1_safe_receiver.length);
        var tmp0_iterator = arrayIterator(tmp1_safe_receiver);
        while (tmp0_iterator.h()) {
          var item = tmp0_iterator.i();
          var tmp$ret$0;
          // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
          tmp$ret$0 = item.ke8();
          tmp0_mapTo.b(tmp$ret$0);
        }
        tmp$ret$1 = tmp0_mapTo;
        tmp$ret$2 = tmp$ret$1;
        tmp = tmp$ret$2;
      }
      return compactArray(tmp);
    };
  }
  function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.zeh());
    };
  }
  function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
    return function (i) {
      return this$0.ve9(i) + ': ' + this$0.te9(i).ne9();
    };
  }
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.neh_1 = serialName;
    this.oeh_1 = generatedSerializer;
    this.peh_1 = elementsCount;
    this.qeh_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.peh_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.reh_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp0_arrayOfNulls = this.peh_1;
    tmp_3.seh_1 = fillArrayVal(Array(tmp0_arrayOfNulls), null);
    this.teh_1 = null;
    this.ueh_1 = booleanArray(this.peh_1);
    this.veh_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.weh_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.xeh_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.yeh_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  protoOf(PluginGeneratedSerialDescriptor).ne9 = function () {
    return this.neh_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).pe9 = function () {
    return this.peh_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).re9 = function () {
    return CLASS_getInstance();
  };
  protoOf(PluginGeneratedSerialDescriptor).oe9 = function () {
    var tmp0_elvis_lhs = this.teh_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).qea = function () {
    return this.veh_1.d2();
  };
  protoOf(PluginGeneratedSerialDescriptor).zeh = function () {
    // Inline function 'kotlin.getValue' call
    typeParameterDescriptors$factory();
    return this.xeh_1.q();
  };
  protoOf(PluginGeneratedSerialDescriptor).aei = function (name, isOptional) {
    this.qeh_1 = this.qeh_1 + 1 | 0;
    this.reh_1[this.qeh_1] = name;
    this.ueh_1[this.qeh_1] = isOptional;
    this.seh_1[this.qeh_1] = null;
    if (this.qeh_1 === (this.peh_1 - 1 | 0)) {
      this.veh_1 = buildIndices(this);
    }
  };
  protoOf(PluginGeneratedSerialDescriptor).te9 = function (index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).ke8();
  };
  protoOf(PluginGeneratedSerialDescriptor).we9 = function (index) {
    return getChecked_0(this.ueh_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).se9 = function (index) {
    var tmp0_elvis_lhs = getChecked(this.seh_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).ve9 = function (index) {
    return getChecked(this.reh_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).ue9 = function (name) {
    var tmp0_elvis_lhs = this.veh_1.c2(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      Companion_getInstance_7();
      tmp = -3;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ne9() === other.ne9())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
      if (!contentEquals(this.zeh(), other.zeh())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.pe9() === other.pe9())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.pe9();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.te9(index).ne9() === other.te9(index).ne9())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.te9(index).re9(), other.te9(index).re9())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
    return _get__hashCode__tgwhef_0(this);
  };
  protoOf(PluginGeneratedSerialDescriptor).toString = function () {
    var tmp = until(0, this.peh_1);
    var tmp_0 = this.ne9() + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  };
  function hashCodeImpl(_this__u8e3s4, typeParams) {
    var result = getStringHashCode(_this__u8e3s4.ne9());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var tmp0_iterator = elementDescriptors.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var tmp0_anonymous = accumulator;
      var tmp = imul(31, tmp0_anonymous);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      var tmp0_safe_receiver = element.ne9();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var namesHash = accumulator;
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator_0 = 1;
    var tmp0_iterator_0 = elementDescriptors.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var tmp0_anonymous_0 = accumulator_0;
      var tmp_0 = imul(31, tmp0_anonymous_0);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      var tmp0_safe_receiver_0 = element_0.re9();
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
      accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    }
    var kindHash = accumulator_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function childSerializers$factory() {
    return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
      return _get_childSerializers__7vnyfa(receiver);
    }, null);
  }
  function typeParameterDescriptors$factory() {
    return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
      return receiver.zeh();
    }, null);
  }
  function _hashCode$factory_0() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef_0(receiver);
    }, null);
  }
  function get_EMPTY_SERIALIZER_ARRAY() {
    _init_properties_PluginHelperInterfaces_kt__xgvzfp();
    return EMPTY_SERIALIZER_ARRAY;
  }
  var EMPTY_SERIALIZER_ARRAY;
  function SerializerFactory() {
  }
  function GeneratedSerializer() {
  }
  var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
  function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
    if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
      properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_SERIALIZER_ARRAY = [];
    }
  }
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_1(Companion_getInstance_1()));
  }
  protoOf(CharArraySerializer_0).qei = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(CharArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.qei((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).rei = function (_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  };
  protoOf(CharArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.rei((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).peg = function () {
    return charArray(0);
  };
  protoOf(CharArraySerializer_0).sei = function (decoder, index, builder, checkIndex) {
    builder.vei(decoder.peb(this.neg_1, index));
  };
  protoOf(CharArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.sei(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).wei = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.sec(this.neg_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(CharArraySerializer_0).qeg = function (encoder, content, size) {
    return this.wei(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_2(DoubleCompanionObject_getInstance()));
  }
  protoOf(DoubleArraySerializer_0).zei = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(DoubleArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.zei((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).aej = function (_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  };
  protoOf(DoubleArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.aej((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).peg = function () {
    return new Float64Array(0);
  };
  protoOf(DoubleArraySerializer_0).bej = function (decoder, index, builder, checkIndex) {
    builder.eej(decoder.oeb(this.neg_1, index));
  };
  protoOf(DoubleArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.bej(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).fej = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.rec(this.neg_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(DoubleArraySerializer_0).qeg = function (encoder, content, size) {
    return this.fej(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_3(FloatCompanionObject_getInstance()));
  }
  protoOf(FloatArraySerializer_0).iej = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(FloatArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.iej((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).jej = function (_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  };
  protoOf(FloatArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.jej((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).peg = function () {
    return new Float32Array(0);
  };
  protoOf(FloatArraySerializer_0).kej = function (decoder, index, builder, checkIndex) {
    builder.nej(decoder.neb(this.neg_1, index));
  };
  protoOf(FloatArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.kej(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).oej = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.qec(this.neg_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(FloatArraySerializer_0).qeg = function (encoder, content, size) {
    return this.oej(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(Companion_getInstance_0()));
  }
  protoOf(LongArraySerializer_0).rej = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(LongArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.rej((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).sej = function (_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  };
  protoOf(LongArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.sej((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).peg = function () {
    return longArray(0);
  };
  protoOf(LongArraySerializer_0).tej = function (decoder, index, builder, checkIndex) {
    builder.wej(decoder.meb(this.neg_1, index));
  };
  protoOf(LongArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.tej(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).xej = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.pec(this.neg_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(LongArraySerializer_0).qeg = function (encoder, content, size) {
    return this.xej(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function ULongArraySerializer_0() {
    ULongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_5(Companion_getInstance_2()));
  }
  protoOf(ULongArraySerializer_0).aek = function (_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.aek(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.f3_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).bek = function (_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.bek(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.f3_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).cek = function () {
    return _ULongArray___init__impl__twm1l3(0);
  };
  protoOf(ULongArraySerializer_0).peg = function () {
    return new ULongArray(this.cek());
  };
  protoOf(ULongArraySerializer_0).dek = function (decoder, index, builder, checkIndex) {
    var tmp$ret$0;
    // Inline function 'kotlin.toULong' call
    var tmp0_toULong = decoder.reb(this.neg_1, index).yea();
    tmp$ret$0 = _ULong___init__impl__c78o9k(tmp0_toULong);
    builder.gek(tmp$ret$0);
  };
  protoOf(ULongArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.dek(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).hek = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.uec(this.neg_1, i);
        var tmp$ret$0;
        // Inline function 'kotlin.ULong.toLong' call
        var tmp0_toLong = ULongArray__get_impl_pr71q9(content, i);
        tmp$ret$0 = _ULong___get_data__impl__fggpzb(tmp0_toLong);
        tmp.fec(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(ULongArraySerializer_0).qeg = function (encoder, content, size) {
    return this.hek(encoder, content instanceof ULongArray ? content.f3_1 : THROW_CCE(), size);
  };
  var ULongArraySerializer_instance;
  function ULongArraySerializer_getInstance() {
    if (ULongArraySerializer_instance == null)
      new ULongArraySerializer_0();
    return ULongArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(IntCompanionObject_getInstance()));
  }
  protoOf(IntArraySerializer_0).kek = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(IntArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.kek((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).lek = function (_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  };
  protoOf(IntArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.lek((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).peg = function () {
    return new Int32Array(0);
  };
  protoOf(IntArraySerializer_0).mek = function (decoder, index, builder, checkIndex) {
    builder.pek(decoder.leb(this.neg_1, index));
  };
  protoOf(IntArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.mek(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).qek = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.oec(this.neg_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(IntArraySerializer_0).qeg = function (encoder, content, size) {
    return this.qek(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function UIntArraySerializer_0() {
    UIntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(Companion_getInstance_3()));
  }
  protoOf(UIntArraySerializer_0).tek = function (_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.tek(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.g3_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).uek = function (_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.uek(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.g3_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).vek = function () {
    return _UIntArray___init__impl__ghjpc6(0);
  };
  protoOf(UIntArraySerializer_0).peg = function () {
    return new UIntArray(this.vek());
  };
  protoOf(UIntArraySerializer_0).wek = function (decoder, index, builder, checkIndex) {
    var tmp$ret$0;
    // Inline function 'kotlin.toUInt' call
    var tmp0_toUInt = decoder.reb(this.neg_1, index).xea();
    tmp$ret$0 = _UInt___init__impl__l7qpdl(tmp0_toUInt);
    builder.zek(tmp$ret$0);
  };
  protoOf(UIntArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.wek(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).ael = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.uec(this.neg_1, i);
        var tmp$ret$0;
        // Inline function 'kotlin.UInt.toInt' call
        var tmp0_toInt = UIntArray__get_impl_gp5kza(content, i);
        tmp$ret$0 = _UInt___get_data__impl__f0vqqw(tmp0_toInt);
        tmp.eec(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UIntArraySerializer_0).qeg = function (encoder, content, size) {
    return this.ael(encoder, content instanceof UIntArray ? content.g3_1 : THROW_CCE(), size);
  };
  var UIntArraySerializer_instance;
  function UIntArraySerializer_getInstance() {
    if (UIntArraySerializer_instance == null)
      new UIntArraySerializer_0();
    return UIntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(ShortCompanionObject_getInstance()));
  }
  protoOf(ShortArraySerializer_0).del = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ShortArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.del((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).eel = function (_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(ShortArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.eel((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).peg = function () {
    return new Int16Array(0);
  };
  protoOf(ShortArraySerializer_0).fel = function (decoder, index, builder, checkIndex) {
    builder.iel(decoder.keb(this.neg_1, index));
  };
  protoOf(ShortArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.fel(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).jel = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.nec(this.neg_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ShortArraySerializer_0).qeg = function (encoder, content, size) {
    return this.jel(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function UShortArraySerializer_0() {
    UShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(Companion_getInstance_4()));
  }
  protoOf(UShortArraySerializer_0).mel = function (_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.mel(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.h3_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).nel = function (_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.nel(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.h3_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).oel = function () {
    return _UShortArray___init__impl__9b26ef(0);
  };
  protoOf(UShortArraySerializer_0).peg = function () {
    return new UShortArray(this.oel());
  };
  protoOf(UShortArraySerializer_0).pel = function (decoder, index, builder, checkIndex) {
    var tmp$ret$0;
    // Inline function 'kotlin.toUShort' call
    var tmp0_toUShort = decoder.reb(this.neg_1, index).wea();
    tmp$ret$0 = _UShort___init__impl__jigrne(tmp0_toUShort);
    builder.sel(tmp$ret$0);
  };
  protoOf(UShortArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.pel(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).tel = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.uec(this.neg_1, i);
        var tmp$ret$0;
        // Inline function 'kotlin.UShort.toShort' call
        var tmp0_toShort = UShortArray__get_impl_fnbhmx(content, i);
        tmp$ret$0 = _UShort___get_data__impl__g0245(tmp0_toShort);
        tmp.dec(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UShortArraySerializer_0).qeg = function (encoder, content, size) {
    return this.tel(encoder, content instanceof UShortArray ? content.h3_1 : THROW_CCE(), size);
  };
  var UShortArraySerializer_instance;
  function UShortArraySerializer_getInstance() {
    if (UShortArraySerializer_instance == null)
      new UShortArraySerializer_0();
    return UShortArraySerializer_instance;
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_10(ByteCompanionObject_getInstance()));
  }
  protoOf(ByteArraySerializer_0).wel = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ByteArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.wel((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).xel = function (_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(ByteArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.xel((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).peg = function () {
    return new Int8Array(0);
  };
  protoOf(ByteArraySerializer_0).yel = function (decoder, index, builder, checkIndex) {
    builder.bem(decoder.jeb(this.neg_1, index));
  };
  protoOf(ByteArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.yel(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).cem = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.mec(this.neg_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ByteArraySerializer_0).qeg = function (encoder, content, size) {
    return this.cem(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function UByteArraySerializer_0() {
    UByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_11(Companion_getInstance_5()));
  }
  protoOf(UByteArraySerializer_0).fem = function (_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.fem(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.i3_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).gem = function (_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.gem(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.i3_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).hem = function () {
    return _UByteArray___init__impl__ip4y9n(0);
  };
  protoOf(UByteArraySerializer_0).peg = function () {
    return new UByteArray(this.hem());
  };
  protoOf(UByteArraySerializer_0).iem = function (decoder, index, builder, checkIndex) {
    var tmp$ret$0;
    // Inline function 'kotlin.toUByte' call
    var tmp0_toUByte = decoder.reb(this.neg_1, index).vea();
    tmp$ret$0 = _UByte___init__impl__g9hnc4(tmp0_toUByte);
    builder.lem(tmp$ret$0);
  };
  protoOf(UByteArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.iem(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).mem = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.uec(this.neg_1, i);
        var tmp$ret$0;
        // Inline function 'kotlin.UByte.toByte' call
        var tmp0_toByte = UByteArray__get_impl_t5f3hv(content, i);
        tmp$ret$0 = _UByte___get_data__impl__jof9qr(tmp0_toByte);
        tmp.cec(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UByteArraySerializer_0).qeg = function (encoder, content, size) {
    return this.mem(encoder, content instanceof UByteArray ? content.i3_1 : THROW_CCE(), size);
  };
  var UByteArraySerializer_instance;
  function UByteArraySerializer_getInstance() {
    if (UByteArraySerializer_instance == null)
      new UByteArraySerializer_0();
    return UByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_12(BooleanCompanionObject_getInstance()));
  }
  protoOf(BooleanArraySerializer_0).pem = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(BooleanArraySerializer_0).nef = function (_this__u8e3s4) {
    return this.pem((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).qem = function (_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  };
  protoOf(BooleanArraySerializer_0).iee = function (_this__u8e3s4) {
    return this.qem((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).peg = function () {
    return booleanArray(0);
  };
  protoOf(BooleanArraySerializer_0).rem = function (decoder, index, builder, checkIndex) {
    builder.uem(decoder.ieb(this.neg_1, index));
  };
  protoOf(BooleanArraySerializer_0).tee = function (decoder, index, builder, checkIndex) {
    return this.rem(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).vem = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.lec(this.neg_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(BooleanArraySerializer_0).qeg = function (encoder, content, size) {
    return this.vem(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.tei_1 = bufferWithData;
    this.uei_1 = bufferWithData.length;
    this.hc(10);
  }
  protoOf(CharArrayBuilder).b39 = function () {
    return this.uei_1;
  };
  protoOf(CharArrayBuilder).hc = function (requiredCapacity) {
    if (this.tei_1.length < requiredCapacity)
      this.tei_1 = copyOf(this.tei_1, coerceAtLeast(requiredCapacity, imul(this.tei_1.length, 2)));
  };
  protoOf(CharArrayBuilder).vei = function (c) {
    this.seg();
    var tmp = this.tei_1;
    var tmp1 = this.uei_1;
    this.uei_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(CharArrayBuilder).gc = function () {
    return copyOf(this.tei_1, this.uei_1);
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.cej_1 = bufferWithData;
    this.dej_1 = bufferWithData.length;
    this.hc(10);
  }
  protoOf(DoubleArrayBuilder).b39 = function () {
    return this.dej_1;
  };
  protoOf(DoubleArrayBuilder).hc = function (requiredCapacity) {
    if (this.cej_1.length < requiredCapacity)
      this.cej_1 = copyOf_0(this.cej_1, coerceAtLeast(requiredCapacity, imul(this.cej_1.length, 2)));
  };
  protoOf(DoubleArrayBuilder).eej = function (c) {
    this.seg();
    var tmp = this.cej_1;
    var tmp1 = this.dej_1;
    this.dej_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(DoubleArrayBuilder).gc = function () {
    return copyOf_0(this.cej_1, this.dej_1);
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.lej_1 = bufferWithData;
    this.mej_1 = bufferWithData.length;
    this.hc(10);
  }
  protoOf(FloatArrayBuilder).b39 = function () {
    return this.mej_1;
  };
  protoOf(FloatArrayBuilder).hc = function (requiredCapacity) {
    if (this.lej_1.length < requiredCapacity)
      this.lej_1 = copyOf_1(this.lej_1, coerceAtLeast(requiredCapacity, imul(this.lej_1.length, 2)));
  };
  protoOf(FloatArrayBuilder).nej = function (c) {
    this.seg();
    var tmp = this.lej_1;
    var tmp1 = this.mej_1;
    this.mej_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(FloatArrayBuilder).gc = function () {
    return copyOf_1(this.lej_1, this.mej_1);
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.uej_1 = bufferWithData;
    this.vej_1 = bufferWithData.length;
    this.hc(10);
  }
  protoOf(LongArrayBuilder).b39 = function () {
    return this.vej_1;
  };
  protoOf(LongArrayBuilder).hc = function (requiredCapacity) {
    if (this.uej_1.length < requiredCapacity)
      this.uej_1 = copyOf_2(this.uej_1, coerceAtLeast(requiredCapacity, imul(this.uej_1.length, 2)));
  };
  protoOf(LongArrayBuilder).wej = function (c) {
    this.seg();
    var tmp = this.uej_1;
    var tmp1 = this.vej_1;
    this.vej_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(LongArrayBuilder).gc = function () {
    return copyOf_2(this.uej_1, this.vej_1);
  };
  function ULongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.eek_1 = bufferWithData;
    this.fek_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.hc(10);
  }
  protoOf(ULongArrayBuilder).b39 = function () {
    return this.fek_1;
  };
  protoOf(ULongArrayBuilder).hc = function (requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.eek_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var tmp0_copyOf = this.eek_1;
      var tmp1_copyOf = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.eek_1), 2));
      tmp.eek_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0_copyOf), tmp1_copyOf));
    }
  };
  protoOf(ULongArrayBuilder).gek = function (c) {
    this.seg();
    var tmp = this.eek_1;
    var tmp1 = this.fek_1;
    this.fek_1 = tmp1 + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, tmp1, c);
  };
  protoOf(ULongArrayBuilder).wem = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var tmp0_copyOf = this.eek_1;
    var tmp1_copyOf = this.fek_1;
    return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0_copyOf), tmp1_copyOf));
  };
  protoOf(ULongArrayBuilder).gc = function () {
    return new ULongArray(this.wem());
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.nek_1 = bufferWithData;
    this.oek_1 = bufferWithData.length;
    this.hc(10);
  }
  protoOf(IntArrayBuilder).b39 = function () {
    return this.oek_1;
  };
  protoOf(IntArrayBuilder).hc = function (requiredCapacity) {
    if (this.nek_1.length < requiredCapacity)
      this.nek_1 = copyOf_3(this.nek_1, coerceAtLeast(requiredCapacity, imul(this.nek_1.length, 2)));
  };
  protoOf(IntArrayBuilder).pek = function (c) {
    this.seg();
    var tmp = this.nek_1;
    var tmp1 = this.oek_1;
    this.oek_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(IntArrayBuilder).gc = function () {
    return copyOf_3(this.nek_1, this.oek_1);
  };
  function UIntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.xek_1 = bufferWithData;
    this.yek_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.hc(10);
  }
  protoOf(UIntArrayBuilder).b39 = function () {
    return this.yek_1;
  };
  protoOf(UIntArrayBuilder).hc = function (requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.xek_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var tmp0_copyOf = this.xek_1;
      var tmp1_copyOf = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.xek_1), 2));
      tmp.xek_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0_copyOf), tmp1_copyOf));
    }
  };
  protoOf(UIntArrayBuilder).zek = function (c) {
    this.seg();
    var tmp = this.xek_1;
    var tmp1 = this.yek_1;
    this.yek_1 = tmp1 + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, tmp1, c);
  };
  protoOf(UIntArrayBuilder).xem = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var tmp0_copyOf = this.xek_1;
    var tmp1_copyOf = this.yek_1;
    return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0_copyOf), tmp1_copyOf));
  };
  protoOf(UIntArrayBuilder).gc = function () {
    return new UIntArray(this.xem());
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.gel_1 = bufferWithData;
    this.hel_1 = bufferWithData.length;
    this.hc(10);
  }
  protoOf(ShortArrayBuilder).b39 = function () {
    return this.hel_1;
  };
  protoOf(ShortArrayBuilder).hc = function (requiredCapacity) {
    if (this.gel_1.length < requiredCapacity)
      this.gel_1 = copyOf_4(this.gel_1, coerceAtLeast(requiredCapacity, imul(this.gel_1.length, 2)));
  };
  protoOf(ShortArrayBuilder).iel = function (c) {
    this.seg();
    var tmp = this.gel_1;
    var tmp1 = this.hel_1;
    this.hel_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ShortArrayBuilder).gc = function () {
    return copyOf_4(this.gel_1, this.hel_1);
  };
  function UShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.qel_1 = bufferWithData;
    this.rel_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.hc(10);
  }
  protoOf(UShortArrayBuilder).b39 = function () {
    return this.rel_1;
  };
  protoOf(UShortArrayBuilder).hc = function (requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.qel_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var tmp0_copyOf = this.qel_1;
      var tmp1_copyOf = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.qel_1), 2));
      tmp.qel_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0_copyOf), tmp1_copyOf));
    }
  };
  protoOf(UShortArrayBuilder).sel = function (c) {
    this.seg();
    var tmp = this.qel_1;
    var tmp1 = this.rel_1;
    this.rel_1 = tmp1 + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, tmp1, c);
  };
  protoOf(UShortArrayBuilder).yem = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var tmp0_copyOf = this.qel_1;
    var tmp1_copyOf = this.rel_1;
    return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0_copyOf), tmp1_copyOf));
  };
  protoOf(UShortArrayBuilder).gc = function () {
    return new UShortArray(this.yem());
  };
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.zel_1 = bufferWithData;
    this.aem_1 = bufferWithData.length;
    this.hc(10);
  }
  protoOf(ByteArrayBuilder).b39 = function () {
    return this.aem_1;
  };
  protoOf(ByteArrayBuilder).hc = function (requiredCapacity) {
    if (this.zel_1.length < requiredCapacity)
      this.zel_1 = copyOf_5(this.zel_1, coerceAtLeast(requiredCapacity, imul(this.zel_1.length, 2)));
  };
  protoOf(ByteArrayBuilder).bem = function (c) {
    this.seg();
    var tmp = this.zel_1;
    var tmp1 = this.aem_1;
    this.aem_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ByteArrayBuilder).gc = function () {
    return copyOf_5(this.zel_1, this.aem_1);
  };
  function UByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.jem_1 = bufferWithData;
    this.kem_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.hc(10);
  }
  protoOf(UByteArrayBuilder).b39 = function () {
    return this.kem_1;
  };
  protoOf(UByteArrayBuilder).hc = function (requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.jem_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var tmp0_copyOf = this.jem_1;
      var tmp1_copyOf = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.jem_1), 2));
      tmp.jem_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0_copyOf), tmp1_copyOf));
    }
  };
  protoOf(UByteArrayBuilder).lem = function (c) {
    this.seg();
    var tmp = this.jem_1;
    var tmp1 = this.kem_1;
    this.kem_1 = tmp1 + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, tmp1, c);
  };
  protoOf(UByteArrayBuilder).zem = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var tmp0_copyOf = this.jem_1;
    var tmp1_copyOf = this.kem_1;
    return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0_copyOf), tmp1_copyOf));
  };
  protoOf(UByteArrayBuilder).gc = function () {
    return new UByteArray(this.zem());
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.sem_1 = bufferWithData;
    this.tem_1 = bufferWithData.length;
    this.hc(10);
  }
  protoOf(BooleanArrayBuilder).b39 = function () {
    return this.tem_1;
  };
  protoOf(BooleanArrayBuilder).hc = function (requiredCapacity) {
    if (this.sem_1.length < requiredCapacity)
      this.sem_1 = copyOf_6(this.sem_1, coerceAtLeast(requiredCapacity, imul(this.sem_1.length, 2)));
  };
  protoOf(BooleanArrayBuilder).uem = function (c) {
    this.seg();
    var tmp = this.sem_1;
    var tmp1 = this.tem_1;
    this.tem_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(BooleanArrayBuilder).gc = function () {
    return copyOf_6(this.sem_1, this.tem_1);
  };
  function get_BUILTIN_SERIALIZERS() {
    _init_properties_Primitives_kt__k0eto4();
    return BUILTIN_SERIALIZERS;
  }
  var BUILTIN_SERIALIZERS;
  function builtinSerializerOrNull(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    var tmp = get_BUILTIN_SERIALIZERS().c2(_this__u8e3s4);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function StringSerializer() {
    StringSerializer_instance = this;
    this.aen_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  protoOf(StringSerializer).ke8 = function () {
    return this.aen_1;
  };
  protoOf(StringSerializer).ben = function (encoder, value) {
    return encoder.jec(value);
  };
  protoOf(StringSerializer).le8 = function (encoder, value) {
    return this.ben(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(StringSerializer).me8 = function (decoder) {
    return decoder.ceb();
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function CharSerializer() {
    CharSerializer_instance = this;
    this.cen_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  protoOf(CharSerializer).ke8 = function () {
    return this.cen_1;
  };
  protoOf(CharSerializer).den = function (encoder, value) {
    return encoder.iec(value);
  };
  protoOf(CharSerializer).le8 = function (encoder, value) {
    return this.den(encoder, value instanceof Char ? value.u7_1 : THROW_CCE());
  };
  protoOf(CharSerializer).een = function (decoder) {
    return decoder.beb();
  };
  protoOf(CharSerializer).me8 = function (decoder) {
    return new Char(this.een(decoder));
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this.fen_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  protoOf(DoubleSerializer).ke8 = function () {
    return this.fen_1;
  };
  protoOf(DoubleSerializer).gen = function (encoder, value) {
    return encoder.hec(value);
  };
  protoOf(DoubleSerializer).le8 = function (encoder, value) {
    return this.gen(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(DoubleSerializer).me8 = function (decoder) {
    return decoder.aeb();
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this.hen_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  protoOf(FloatSerializer).ke8 = function () {
    return this.hen_1;
  };
  protoOf(FloatSerializer).ien = function (encoder, value) {
    return encoder.gec(value);
  };
  protoOf(FloatSerializer).le8 = function (encoder, value) {
    return this.ien(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(FloatSerializer).me8 = function (decoder) {
    return decoder.zea();
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this.jen_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  protoOf(LongSerializer).ke8 = function () {
    return this.jen_1;
  };
  protoOf(LongSerializer).ken = function (encoder, value) {
    return encoder.fec(value);
  };
  protoOf(LongSerializer).le8 = function (encoder, value) {
    return this.ken(encoder, value instanceof Long ? value : THROW_CCE());
  };
  protoOf(LongSerializer).me8 = function (decoder) {
    return decoder.yea();
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this.len_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  protoOf(IntSerializer).ke8 = function () {
    return this.len_1;
  };
  protoOf(IntSerializer).men = function (encoder, value) {
    return encoder.eec(value);
  };
  protoOf(IntSerializer).le8 = function (encoder, value) {
    return this.men(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(IntSerializer).me8 = function (decoder) {
    return decoder.xea();
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this.nen_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  protoOf(ShortSerializer).ke8 = function () {
    return this.nen_1;
  };
  protoOf(ShortSerializer).oen = function (encoder, value) {
    return encoder.dec(value);
  };
  protoOf(ShortSerializer).le8 = function (encoder, value) {
    return this.oen(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ShortSerializer).me8 = function (decoder) {
    return decoder.wea();
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this.pen_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  protoOf(ByteSerializer).ke8 = function () {
    return this.pen_1;
  };
  protoOf(ByteSerializer).qen = function (encoder, value) {
    return encoder.cec(value);
  };
  protoOf(ByteSerializer).le8 = function (encoder, value) {
    return this.qen(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ByteSerializer).me8 = function (decoder) {
    return decoder.vea();
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this.ren_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  protoOf(BooleanSerializer).ke8 = function () {
    return this.ren_1;
  };
  protoOf(BooleanSerializer).sen = function (encoder, value) {
    return encoder.bec(value);
  };
  protoOf(BooleanSerializer).le8 = function (encoder, value) {
    return this.sen(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(BooleanSerializer).me8 = function (decoder) {
    return decoder.uea();
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this.ten_1 = new ObjectSerializer('kotlin.Unit', Unit_getInstance());
  }
  protoOf(UnitSerializer).ke8 = function () {
    return this.ten_1.ke8();
  };
  protoOf(UnitSerializer).uen = function (decoder) {
    this.ten_1.me8(decoder);
  };
  protoOf(UnitSerializer).me8 = function (decoder) {
    this.uen(decoder);
    return Unit_getInstance();
  };
  protoOf(UnitSerializer).ven = function (encoder, value) {
    this.ten_1.le8(encoder, Unit_getInstance());
  };
  protoOf(UnitSerializer).le8 = function (encoder, value) {
    return this.ven(encoder, value instanceof Unit ? value : THROW_CCE());
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  function error_0($this) {
    throw IllegalStateException_init_$Create$('Primitive descriptor does not have elements');
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this.wen_1 = serialName;
    this.xen_1 = kind;
  }
  protoOf(PrimitiveSerialDescriptor_0).ne9 = function () {
    return this.wen_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).re9 = function () {
    return this.xen_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).pe9 = function () {
    return 0;
  };
  protoOf(PrimitiveSerialDescriptor_0).ve9 = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).ue9 = function (name) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).we9 = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).te9 = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).se9 = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).toString = function () {
    return 'PrimitiveDescriptor(' + this.wen_1 + ')';
  };
  protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor_0))
      return false;
    if (this.wen_1 === other.wen_1 ? equals(this.xen_1, other.xen_1) : false)
      return true;
    return false;
  };
  protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
    return getStringHashCode(this.wen_1) + imul(31, this.xen_1.hashCode()) | 0;
  };
  function PrimitiveDescriptorSafe(serialName, kind) {
    _init_properties_Primitives_kt__k0eto4();
    checkName(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function checkName(serialName) {
    _init_properties_Primitives_kt__k0eto4();
    var keys = get_BUILTIN_SERIALIZERS().d2();
    var tmp0_iterator = keys.g();
    while (tmp0_iterator.h()) {
      var primitive = tmp0_iterator.i();
      var simpleName = capitalize(ensureNotNull(primitive.ue()));
      var qualifiedName = 'kotlin.' + simpleName;
      if (equals_0(serialName, qualifiedName, true) ? true : equals_0(serialName, simpleName, true)) {
        throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }
    }
  }
  function capitalize(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(_this__u8e3s4) > 0) {
      var tmp$ret$1;
      // Inline function 'kotlinx.serialization.internal.capitalize.<anonymous>' call
      var tmp0_anonymous = charSequenceGet(_this__u8e3s4, 0);
      tmp$ret$1 = isLowerCase(tmp0_anonymous) ? titlecase(tmp0_anonymous) : toString_0(tmp0_anonymous);
      var tmp_0 = toString(tmp$ret$1);
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp_0 + _this__u8e3s4.substring(1);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  var properties_initialized_Primitives_kt_6dpii6;
  function _init_properties_Primitives_kt__k0eto4() {
    if (!properties_initialized_Primitives_kt_6dpii6) {
      properties_initialized_Primitives_kt_6dpii6 = true;
      BUILTIN_SERIALIZERS = mapOf([to(PrimitiveClasses_getInstance().tf(), serializer_0(StringCompanionObject_getInstance())), to(getKClass(Char), serializer_1(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().wf(), CharArraySerializer()), to(PrimitiveClasses_getInstance().rf(), serializer_2(DoubleCompanionObject_getInstance())), to(PrimitiveClasses_getInstance().cg(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().qf(), serializer_3(FloatCompanionObject_getInstance())), to(PrimitiveClasses_getInstance().bg(), FloatArraySerializer()), to(getKClass(Long), serializer_4(Companion_getInstance_0())), to(PrimitiveClasses_getInstance().ag(), LongArraySerializer()), to(getKClass(ULong), serializer_5(Companion_getInstance_2())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().pf(), serializer_6(IntCompanionObject_getInstance())), to(PrimitiveClasses_getInstance().zf(), IntArraySerializer()), to(getKClass(UInt), serializer_7(Companion_getInstance_3())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().of(), serializer_8(ShortCompanionObject_getInstance())), to(PrimitiveClasses_getInstance().yf(), ShortArraySerializer()), to(getKClass(UShort), serializer_9(Companion_getInstance_4())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().nf(), serializer_10(ByteCompanionObject_getInstance())), to(PrimitiveClasses_getInstance().xf(), ByteArraySerializer()), to(getKClass(UByte), serializer_11(Companion_getInstance_5())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().mf(), serializer_12(BooleanCompanionObject_getInstance())), to(PrimitiveClasses_getInstance().vf(), BooleanArraySerializer()), to(getKClass(Unit), serializer_13(Unit_getInstance())), to(PrimitiveClasses_getInstance().lf(), NothingSerializer()), to(getKClass(Duration), serializer_14(Companion_getInstance()))]);
    }
  }
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  protoOf(NamedValueDecoder).aeo = function (_this__u8e3s4, index) {
    return this.ceo(this.beo(_this__u8e3s4, index));
  };
  protoOf(NamedValueDecoder).ceo = function (nestedName) {
    var tmp0_elvis_lhs = this.feo();
    return this.geo(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueDecoder).beo = function (descriptor, index) {
    return descriptor.ve9(index);
  };
  protoOf(NamedValueDecoder).geo = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  function tagBlock($this, tag, block) {
    $this.teo(tag);
    var r = block();
    if (!$this.eeo_1) {
      $this.ueo();
    }
    $this.eeo_1 = false;
    return r;
  }
  function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.eeb($deserializer, $previousValue);
    };
  }
  function TaggedDecoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.deo_1 = ArrayList_init_$Create$_0();
    this.eeo_1 = false;
  }
  protoOf(TaggedDecoder).ueb = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedDecoder).heo = function (tag) {
    throw SerializationException_init_$Create$('' + getKClassFromExpression(this) + " can't retrieve untyped values");
  };
  protoOf(TaggedDecoder).ieo = function (tag) {
    return true;
  };
  protoOf(TaggedDecoder).jeo = function (tag) {
    var tmp = this.heo(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).keo = function (tag) {
    var tmp = this.heo(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).leo = function (tag) {
    var tmp = this.heo(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).meo = function (tag) {
    var tmp = this.heo(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).neo = function (tag) {
    var tmp = this.heo(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).oeo = function (tag) {
    var tmp = this.heo(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).peo = function (tag) {
    var tmp = this.heo(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).qeo = function (tag) {
    var tmp = this.heo(tag);
    return tmp instanceof Char ? tmp.u7_1 : THROW_CCE();
  };
  protoOf(TaggedDecoder).reo = function (tag) {
    var tmp = this.heo(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).seo = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeTaggedInline.<anonymous>' call
    this.teo(tag);
    return this;
  };
  protoOf(TaggedDecoder).eeb = function (deserializer, previousValue) {
    return this.feb(deserializer);
  };
  protoOf(TaggedDecoder).deb = function (descriptor) {
    return this.seo(this.ueo(), descriptor);
  };
  protoOf(TaggedDecoder).sea = function () {
    var tmp0_elvis_lhs = this.feo();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.ieo(currentTag);
  };
  protoOf(TaggedDecoder).tea = function () {
    return null;
  };
  protoOf(TaggedDecoder).uea = function () {
    return this.jeo(this.ueo());
  };
  protoOf(TaggedDecoder).vea = function () {
    return this.keo(this.ueo());
  };
  protoOf(TaggedDecoder).wea = function () {
    return this.leo(this.ueo());
  };
  protoOf(TaggedDecoder).xea = function () {
    return this.meo(this.ueo());
  };
  protoOf(TaggedDecoder).yea = function () {
    return this.neo(this.ueo());
  };
  protoOf(TaggedDecoder).zea = function () {
    return this.oeo(this.ueo());
  };
  protoOf(TaggedDecoder).aeb = function () {
    return this.peo(this.ueo());
  };
  protoOf(TaggedDecoder).beb = function () {
    return this.qeo(this.ueo());
  };
  protoOf(TaggedDecoder).ceb = function () {
    return this.reo(this.ueo());
  };
  protoOf(TaggedDecoder).geb = function (descriptor) {
    return this;
  };
  protoOf(TaggedDecoder).heb = function (descriptor) {
  };
  protoOf(TaggedDecoder).ieb = function (descriptor, index) {
    return this.jeo(this.aeo(descriptor, index));
  };
  protoOf(TaggedDecoder).jeb = function (descriptor, index) {
    return this.keo(this.aeo(descriptor, index));
  };
  protoOf(TaggedDecoder).keb = function (descriptor, index) {
    return this.leo(this.aeo(descriptor, index));
  };
  protoOf(TaggedDecoder).leb = function (descriptor, index) {
    return this.meo(this.aeo(descriptor, index));
  };
  protoOf(TaggedDecoder).meb = function (descriptor, index) {
    return this.neo(this.aeo(descriptor, index));
  };
  protoOf(TaggedDecoder).neb = function (descriptor, index) {
    return this.oeo(this.aeo(descriptor, index));
  };
  protoOf(TaggedDecoder).oeb = function (descriptor, index) {
    return this.peo(this.aeo(descriptor, index));
  };
  protoOf(TaggedDecoder).peb = function (descriptor, index) {
    return this.qeo(this.aeo(descriptor, index));
  };
  protoOf(TaggedDecoder).qeb = function (descriptor, index) {
    return this.reo(this.aeo(descriptor, index));
  };
  protoOf(TaggedDecoder).reb = function (descriptor, index) {
    return this.seo(this.aeo(descriptor, index), descriptor.te9(index));
  };
  protoOf(TaggedDecoder).seb = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.aeo(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).feo = function () {
    return lastOrNull(this.deo_1);
  };
  protoOf(TaggedDecoder).teo = function (name) {
    this.deo_1.b(name);
  };
  protoOf(TaggedDecoder).ueo = function () {
    var r = this.deo_1.x2(get_lastIndex_0(this.deo_1));
    this.eeo_1 = true;
    return r;
  };
  function get_NULL() {
    _init_properties_Tuples_kt__dz0qyd();
    return NULL;
  }
  var NULL;
  function MapEntry(key, value) {
    this.veo_1 = key;
    this.weo_1 = value;
  }
  protoOf(MapEntry).p = function () {
    return this.veo_1;
  };
  protoOf(MapEntry).q = function () {
    return this.weo_1;
  };
  protoOf(MapEntry).toString = function () {
    return 'MapEntry(key=' + this.veo_1 + ', value=' + this.weo_1 + ')';
  };
  protoOf(MapEntry).hashCode = function () {
    var result = this.veo_1 == null ? 0 : hashCode(this.veo_1);
    result = imul(result, 31) + (this.weo_1 == null ? 0 : hashCode(this.weo_1)) | 0;
    return result;
  };
  protoOf(MapEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.veo_1, tmp0_other_with_cast.veo_1))
      return false;
    if (!equals(this.weo_1, tmp0_other_with_cast.weo_1))
      return false;
    return true;
  };
  function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.ve8('key', $keySerializer.ke8());
      $this$buildSerialDescriptor.ve8('value', $valueSerializer.ke8());
      return Unit_getInstance();
    };
  }
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.zeo_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(MapEntrySerializer_0).ke8 = function () {
    return this.zeo_1;
  };
  protoOf(MapEntrySerializer_0).aep = function (_this__u8e3s4) {
    return _this__u8e3s4.p();
  };
  protoOf(MapEntrySerializer_0).bep = function (_this__u8e3s4) {
    return this.aep((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).cep = function (_this__u8e3s4) {
    return _this__u8e3s4.q();
  };
  protoOf(MapEntrySerializer_0).dep = function (_this__u8e3s4) {
    return this.cep((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).eep = function (key, value) {
    return new MapEntry(key, value);
  };
  function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.ve8('first', $keySerializer.ke8());
      $this$buildClassSerialDescriptor.ve8('second', $valueSerializer.ke8());
      return Unit_getInstance();
    };
  }
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    tmp.kep_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(PairSerializer_0).ke8 = function () {
    return this.kep_1;
  };
  protoOf(PairSerializer_0).lep = function (_this__u8e3s4) {
    return _this__u8e3s4.c4_1;
  };
  protoOf(PairSerializer_0).bep = function (_this__u8e3s4) {
    return this.lep(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).mep = function (_this__u8e3s4) {
    return _this__u8e3s4.d4_1;
  };
  protoOf(PairSerializer_0).dep = function (_this__u8e3s4) {
    return this.mep(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).eep = function (key, value) {
    return to(key, value);
  };
  function decodeSequentially_1($this, composite) {
    var a = composite.teb($this.qep_1, 0, $this.nep_1);
    var b = composite.teb($this.qep_1, 1, $this.oep_1);
    var c = composite.teb($this.qep_1, 2, $this.pep_1);
    composite.heb($this.qep_1);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = get_NULL();
    var b = get_NULL();
    var c = get_NULL();
    mainLoop: while (true) {
      var index = composite.web($this.qep_1);
      Companion_getInstance_7();
      if (index === -1) {
        break mainLoop;
      } else {
        if (index === 0) {
          a = composite.teb($this.qep_1, 0, $this.nep_1);
        } else {
          if (index === 1) {
            b = composite.teb($this.qep_1, 1, $this.oep_1);
          } else {
            if (index === 2) {
              c = composite.teb($this.qep_1, 2, $this.pep_1);
            } else {
              throw SerializationException_init_$Create$('Unexpected index ' + index);
            }
          }
        }
      }
    }
    composite.heb($this.qep_1);
    if (a === get_NULL())
      throw SerializationException_init_$Create$("Element 'first' is missing");
    if (b === get_NULL())
      throw SerializationException_init_$Create$("Element 'second' is missing");
    if (c === get_NULL())
      throw SerializationException_init_$Create$("Element 'third' is missing");
    var tmp = (a == null ? true : isObject(a)) ? a : THROW_CCE();
    var tmp_0 = (b == null ? true : isObject(b)) ? b : THROW_CCE();
    return new Triple(tmp, tmp_0, (c == null ? true : isObject(c)) ? c : THROW_CCE());
  }
  function TripleSerializer$descriptor$lambda(this$0) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.ve8('first', this$0.nep_1.ke8());
      $this$buildClassSerialDescriptor.ve8('second', this$0.oep_1.ke8());
      $this$buildClassSerialDescriptor.ve8('third', this$0.pep_1.ke8());
      return Unit_getInstance();
    };
  }
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this.nep_1 = aSerializer;
    this.oep_1 = bSerializer;
    this.pep_1 = cSerializer;
    var tmp = this;
    tmp.qep_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  protoOf(TripleSerializer_0).ke8 = function () {
    return this.qep_1;
  };
  protoOf(TripleSerializer_0).rep = function (encoder, value) {
    var structuredEncoder = encoder.geb(this.qep_1);
    structuredEncoder.vec(this.qep_1, 0, this.nep_1, value.l9_1);
    structuredEncoder.vec(this.qep_1, 1, this.oep_1, value.m9_1);
    structuredEncoder.vec(this.qep_1, 2, this.pep_1, value.n9_1);
    structuredEncoder.heb(this.qep_1);
  };
  protoOf(TripleSerializer_0).le8 = function (encoder, value) {
    return this.rep(encoder, value instanceof Triple ? value : THROW_CCE());
  };
  protoOf(TripleSerializer_0).me8 = function (decoder) {
    var composite = decoder.geb(this.qep_1);
    if (composite.veb()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this.fep_1 = keySerializer;
    this.gep_1 = valueSerializer;
  }
  protoOf(KeyValueSerializer).hep = function (encoder, value) {
    var structuredEncoder = encoder.geb(this.ke8());
    structuredEncoder.vec(this.ke8(), 0, this.fep_1, this.bep(value));
    structuredEncoder.vec(this.ke8(), 1, this.gep_1, this.dep(value));
    structuredEncoder.heb(this.ke8());
  };
  protoOf(KeyValueSerializer).le8 = function (encoder, value) {
    return this.hep(encoder, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  protoOf(KeyValueSerializer).me8 = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var tmp0_decodeStructure = this.ke8();
    var composite = decoder.geb(tmp0_decodeStructure);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.KeyValueSerializer.deserialize.<anonymous>' call
      if (composite.veb()) {
        var key = composite.teb(this.ke8(), 0, this.fep_1);
        var value = composite.teb(this.ke8(), 1, this.gep_1);
        tmp$ret$0 = this.eep(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.web(this.ke8());
        Companion_getInstance_7();
        if (idx === -1) {
          break mainLoop;
        } else {
          if (idx === 0) {
            key_0 = composite.teb(this.ke8(), 0, this.fep_1);
          } else {
            if (idx === 1) {
              value_0 = composite.teb(this.ke8(), 1, this.gep_1);
            } else {
              throw SerializationException_init_$Create$('Invalid index: ' + idx);
            }
          }
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException_init_$Create$("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException_init_$Create$("Element 'value' is missing");
      var tmp = (key_0 == null ? true : isObject(key_0)) ? key_0 : THROW_CCE();
      tmp$ret$0 = this.eep(tmp, (value_0 == null ? true : isObject(value_0)) ? value_0 : THROW_CCE());
    }
    var result = tmp$ret$0;
    composite.heb(tmp0_decodeStructure);
    return result;
  };
  var properties_initialized_Tuples_kt_3vs7ar;
  function _init_properties_Tuples_kt__dz0qyd() {
    if (!properties_initialized_Tuples_kt_3vs7ar) {
      properties_initialized_Tuples_kt_3vs7ar = true;
      NULL = new Object();
    }
  }
  function ULongSerializer() {
    ULongSerializer_instance = this;
    this.sep_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_4(Companion_getInstance_0()));
  }
  protoOf(ULongSerializer).ke8 = function () {
    return this.sep_1;
  };
  protoOf(ULongSerializer).tep = function (encoder, value) {
    var tmp = encoder.kec(this.sep_1);
    var tmp$ret$0;
    // Inline function 'kotlin.ULong.toLong' call
    tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.fec(tmp$ret$0);
  };
  protoOf(ULongSerializer).le8 = function (encoder, value) {
    return this.tep(encoder, value instanceof ULong ? value.oa_1 : THROW_CCE());
  };
  protoOf(ULongSerializer).uep = function (decoder) {
    // Inline function 'kotlin.toULong' call
    var tmp0_toULong = decoder.deb(this.sep_1).yea();
    return _ULong___init__impl__c78o9k(tmp0_toULong);
  };
  protoOf(ULongSerializer).me8 = function (decoder) {
    return new ULong(this.uep(decoder));
  };
  var ULongSerializer_instance;
  function ULongSerializer_getInstance() {
    if (ULongSerializer_instance == null)
      new ULongSerializer();
    return ULongSerializer_instance;
  }
  function UIntSerializer() {
    UIntSerializer_instance = this;
    this.vep_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_6(IntCompanionObject_getInstance()));
  }
  protoOf(UIntSerializer).ke8 = function () {
    return this.vep_1;
  };
  protoOf(UIntSerializer).wep = function (encoder, value) {
    var tmp = encoder.kec(this.vep_1);
    var tmp$ret$0;
    // Inline function 'kotlin.UInt.toInt' call
    tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.eec(tmp$ret$0);
  };
  protoOf(UIntSerializer).le8 = function (encoder, value) {
    return this.wep(encoder, value instanceof UInt ? value.da_1 : THROW_CCE());
  };
  protoOf(UIntSerializer).xep = function (decoder) {
    // Inline function 'kotlin.toUInt' call
    var tmp0_toUInt = decoder.deb(this.vep_1).xea();
    return _UInt___init__impl__l7qpdl(tmp0_toUInt);
  };
  protoOf(UIntSerializer).me8 = function (decoder) {
    return new UInt(this.xep(decoder));
  };
  var UIntSerializer_instance;
  function UIntSerializer_getInstance() {
    if (UIntSerializer_instance == null)
      new UIntSerializer();
    return UIntSerializer_instance;
  }
  function UShortSerializer() {
    UShortSerializer_instance = this;
    this.yep_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_8(ShortCompanionObject_getInstance()));
  }
  protoOf(UShortSerializer).ke8 = function () {
    return this.yep_1;
  };
  protoOf(UShortSerializer).zep = function (encoder, value) {
    var tmp = encoder.kec(this.yep_1);
    var tmp$ret$0;
    // Inline function 'kotlin.UShort.toShort' call
    tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.dec(tmp$ret$0);
  };
  protoOf(UShortSerializer).le8 = function (encoder, value) {
    return this.zep(encoder, value instanceof UShort ? value.ya_1 : THROW_CCE());
  };
  protoOf(UShortSerializer).aeq = function (decoder) {
    // Inline function 'kotlin.toUShort' call
    var tmp0_toUShort = decoder.deb(this.yep_1).wea();
    return _UShort___init__impl__jigrne(tmp0_toUShort);
  };
  protoOf(UShortSerializer).me8 = function (decoder) {
    return new UShort(this.aeq(decoder));
  };
  var UShortSerializer_instance;
  function UShortSerializer_getInstance() {
    if (UShortSerializer_instance == null)
      new UShortSerializer();
    return UShortSerializer_instance;
  }
  function UByteSerializer() {
    UByteSerializer_instance = this;
    this.beq_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_10(ByteCompanionObject_getInstance()));
  }
  protoOf(UByteSerializer).ke8 = function () {
    return this.beq_1;
  };
  protoOf(UByteSerializer).ceq = function (encoder, value) {
    var tmp = encoder.kec(this.beq_1);
    var tmp$ret$0;
    // Inline function 'kotlin.UByte.toByte' call
    tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.cec(tmp$ret$0);
  };
  protoOf(UByteSerializer).le8 = function (encoder, value) {
    return this.ceq(encoder, value instanceof UByte ? value.t9_1 : THROW_CCE());
  };
  protoOf(UByteSerializer).deq = function (decoder) {
    // Inline function 'kotlin.toUByte' call
    var tmp0_toUByte = decoder.deb(this.beq_1).vea();
    return _UByte___init__impl__g9hnc4(tmp0_toUByte);
  };
  protoOf(UByteSerializer).me8 = function (decoder) {
    return new UByte(this.deq(decoder));
  };
  var UByteSerializer_instance;
  function UByteSerializer_getInstance() {
    if (UByteSerializer_instance == null)
      new UByteSerializer();
    return UByteSerializer_instance;
  }
  function get_EmptySerializersModuleLegacyJs() {
    _init_properties_SerializersModule_kt__u78ha3();
    return EmptySerializersModule;
  }
  var EmptySerializersModule;
  function SerializersModule() {
  }
  protoOf(SerializersModule).ge9 = function (kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.fe9(kClass, typeArgumentsSerializers) : $super.fe9.call(this, kClass, typeArgumentsSerializers);
  };
  function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider) {
    SerializersModule.call(this);
    this.eeq_1 = class2ContextualFactory;
    this.feq_1 = polyBase2Serializers;
    this.geq_1 = polyBase2DefaultSerializerProvider;
    this.heq_1 = polyBase2NamedSerializers;
    this.ieq_1 = polyBase2DefaultDeserializerProvider;
  }
  protoOf(SerialModuleImpl).ded = function (baseClass, value) {
    if (!baseClass.ve(value))
      return null;
    var tmp0_safe_receiver = this.feq_1.c2(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c2(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.geq_1.c2(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  };
  protoOf(SerialModuleImpl).ced = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.heq_1.c2(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = ((!(tmp0_safe_receiver == null) ? isInterface(tmp0_safe_receiver, Map) : false) ? tmp0_safe_receiver : THROW_CCE()).c2(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.ieq_1.c2(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  protoOf(SerialModuleImpl).fe9 = function (kClass, typeArgumentsSerializers) {
    var tmp0_safe_receiver = this.eeq_1.c2(kClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.jeq(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  };
  var properties_initialized_SerializersModule_kt_fjigjn;
  function _init_properties_SerializersModule_kt__u78ha3() {
    if (!properties_initialized_SerializersModule_kt_fjigjn) {
      properties_initialized_SerializersModule_kt_fjigjn = true;
      EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap());
    }
  }
  function EmptySerializersModule_0() {
    return get_EmptySerializersModuleLegacyJs();
  }
  function SerializableWith(serializer) {
    this.keq_1 = serializer;
  }
  protoOf(SerializableWith).equals = function (other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.keq_1.equals(tmp0_other_with_cast.keq_1))
      return false;
    return true;
  };
  protoOf(SerializableWith).hashCode = function () {
    return imul(getStringHashCode('serializer'), 127) ^ this.keq_1.hashCode();
  };
  protoOf(SerializableWith).toString = function () {
    return '@kotlinx.serialization.SerializableWith(serializer=' + this.keq_1 + ')';
  };
  function createCache(factory) {
    return new createCache$1(factory);
  }
  function createParametrizedCache(factory) {
    return new createParametrizedCache$1(factory);
  }
  function compiledSerializerImpl(_this__u8e3s4) {
    var tmp1_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp_0;
      if (_this__u8e3s4 === PrimitiveClasses_getInstance().lf()) {
        tmp_0 = NothingSerializer_getInstance();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = get_js(_this__u8e3s4).Companion;
        tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
      }
      var tmp_1 = tmp_0;
      tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
    throw SerializationException_init_$Create$(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance().sf());
  }
  function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
    var tmp;
    try {
      // Inline function 'kotlin.reflect.findAssociatedObject' call
      var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.nei(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          if (get_isInterface(_this__u8e3s4)) {
            tmp_0 = new PolymorphicSerializer(_this__u8e3s4);
          } else {
            tmp_0 = null;
          }
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      var e = $p;
      tmp_2 = null;
      tmp = tmp_2;
    }
    return tmp;
  }
  function get_isInterface(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
  }
  function toNativeArrayImpl(_this__u8e3s4, eClass) {
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(_this__u8e3s4);
  }
  function getChecked(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4));
    return _this__u8e3s4[index];
  }
  function getChecked_0(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4));
    return _this__u8e3s4[index];
  }
  function createCache$1($factory) {
    this.leq_1 = $factory;
  }
  protoOf(createCache$1).he9 = function (key) {
    return this.leq_1(key);
  };
  function createParametrizedCache$1($factory) {
    this.meq_1 = $factory;
  }
  protoOf(createParametrizedCache$1).ie9 = function (key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      Companion_getInstance_6();
      // Inline function 'kotlinx.serialization.internal.<no name provided>.get.<anonymous>' call
      var tmp1_success = this.meq_1(key, types);
      tmp = _Result___init__impl__xyqfz8(tmp1_success);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        Companion_getInstance_6();
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  //region block: post-declaration
  protoOf(SerialDescriptorImpl).je9 = get_isNullable;
  protoOf(SerialDescriptorImpl).qe9 = get_isInline;
  protoOf(AbstractDecoder).teb = decodeSerializableElement$default;
  protoOf(AbstractDecoder).feb = decodeSerializableValue;
  protoOf(AbstractDecoder).veb = decodeSequentially;
  protoOf(AbstractDecoder).xeb = decodeCollectionSize;
  protoOf(AbstractEncoder).xec = encodeNotNullMark;
  protoOf(AbstractEncoder).yec = beginCollection;
  protoOf(AbstractEncoder).wec = encodeSerializableValue;
  protoOf(AbstractEncoder).zec = shouldEncodeElementDefault;
  protoOf(ListLikeDescriptor).je9 = get_isNullable;
  protoOf(ListLikeDescriptor).qe9 = get_isInline;
  protoOf(ListLikeDescriptor).oe9 = get_annotations;
  protoOf(ArrayListClassDesc).je9 = get_isNullable;
  protoOf(ArrayListClassDesc).qe9 = get_isInline;
  protoOf(ArrayListClassDesc).oe9 = get_annotations;
  protoOf(HashSetClassDesc).je9 = get_isNullable;
  protoOf(HashSetClassDesc).qe9 = get_isInline;
  protoOf(HashSetClassDesc).oe9 = get_annotations;
  protoOf(LinkedHashSetClassDesc).je9 = get_isNullable;
  protoOf(LinkedHashSetClassDesc).qe9 = get_isInline;
  protoOf(LinkedHashSetClassDesc).oe9 = get_annotations;
  protoOf(MapLikeDescriptor).je9 = get_isNullable;
  protoOf(MapLikeDescriptor).qe9 = get_isInline;
  protoOf(MapLikeDescriptor).oe9 = get_annotations;
  protoOf(HashMapClassDesc).je9 = get_isNullable;
  protoOf(HashMapClassDesc).qe9 = get_isInline;
  protoOf(HashMapClassDesc).oe9 = get_annotations;
  protoOf(LinkedHashMapClassDesc).je9 = get_isNullable;
  protoOf(LinkedHashMapClassDesc).qe9 = get_isInline;
  protoOf(LinkedHashMapClassDesc).oe9 = get_annotations;
  protoOf(ArrayClassDesc).je9 = get_isNullable;
  protoOf(ArrayClassDesc).qe9 = get_isInline;
  protoOf(ArrayClassDesc).oe9 = get_annotations;
  protoOf(PrimitiveArrayDescriptor).je9 = get_isNullable;
  protoOf(PrimitiveArrayDescriptor).qe9 = get_isInline;
  protoOf(PrimitiveArrayDescriptor).oe9 = get_annotations;
  protoOf(PluginGeneratedSerialDescriptor).je9 = get_isNullable;
  protoOf(PluginGeneratedSerialDescriptor).qe9 = get_isInline;
  protoOf(InlineClassDescriptor).je9 = get_isNullable;
  protoOf(InlinePrimitiveDescriptor$1).dei = typeParametersSerializers;
  protoOf(NoOpEncoder).xec = encodeNotNullMark;
  protoOf(NoOpEncoder).yec = beginCollection;
  protoOf(NoOpEncoder).wec = encodeSerializableValue;
  protoOf(NoOpEncoder).zec = shouldEncodeElementDefault;
  protoOf(NothingSerialDescriptor).je9 = get_isNullable;
  protoOf(NothingSerialDescriptor).qe9 = get_isInline;
  protoOf(NothingSerialDescriptor).oe9 = get_annotations;
  protoOf(PrimitiveSerialDescriptor_0).je9 = get_isNullable;
  protoOf(PrimitiveSerialDescriptor_0).qe9 = get_isInline;
  protoOf(PrimitiveSerialDescriptor_0).oe9 = get_annotations;
  protoOf(TaggedDecoder).teb = decodeSerializableElement$default;
  protoOf(TaggedDecoder).feb = decodeSerializableValue;
  protoOf(TaggedDecoder).veb = decodeSequentially;
  protoOf(TaggedDecoder).xeb = decodeCollectionSize;
  protoOf(NamedValueDecoder).feb = decodeSerializableValue;
  protoOf(NamedValueDecoder).teb = decodeSerializableElement$default;
  protoOf(NamedValueDecoder).veb = decodeSequentially;
  protoOf(NamedValueDecoder).xeb = decodeCollectionSize;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = decodeSerializableElement$default;
  _.$_$.b = SerializationException_init_$Init$;
  _.$_$.c = UnknownFieldException_init_$Create$;
  _.$_$.d = SEALED_getInstance;
  _.$_$.e = STRING_getInstance;
  _.$_$.f = CONTEXTUAL_getInstance;
  _.$_$.g = ENUM_getInstance;
  _.$_$.h = CLASS_getInstance;
  _.$_$.i = LIST_getInstance;
  _.$_$.j = MAP_getInstance;
  _.$_$.k = Companion_getInstance_7;
  _.$_$.l = DoubleSerializer_getInstance;
  _.$_$.m = IntSerializer_getInstance;
  _.$_$.n = LongSerializer_getInstance;
  _.$_$.o = StringSerializer_getInstance;
  _.$_$.p = ListSerializer;
  _.$_$.q = MapSerializer;
  _.$_$.r = serializer_0;
  _.$_$.s = serializer_9;
  _.$_$.t = serializer_7;
  _.$_$.u = serializer_11;
  _.$_$.v = serializer_5;
  _.$_$.w = PolymorphicKind;
  _.$_$.x = PrimitiveKind;
  _.$_$.y = PrimitiveSerialDescriptor;
  _.$_$.z = get_annotations;
  _.$_$.a1 = get_isInline;
  _.$_$.b1 = get_isNullable;
  _.$_$.c1 = SerialDescriptor;
  _.$_$.d1 = ENUM;
  _.$_$.e1 = buildSerialDescriptor;
  _.$_$.f1 = getContextualDescriptor;
  _.$_$.g1 = AbstractDecoder;
  _.$_$.h1 = AbstractEncoder;
  _.$_$.i1 = decodeCollectionSize;
  _.$_$.j1 = decodeSequentially;
  _.$_$.k1 = CompositeDecoder;
  _.$_$.l1 = CompositeEncoder;
  _.$_$.m1 = decodeSerializableValue;
  _.$_$.n1 = Decoder;
  _.$_$.o1 = beginCollection;
  _.$_$.p1 = encodeNotNullMark;
  _.$_$.q1 = Encoder;
  _.$_$.r1 = AbstractPolymorphicSerializer;
  _.$_$.s1 = ArrayListSerializer;
  _.$_$.t1 = ElementMarker;
  _.$_$.u1 = typeParametersSerializers;
  _.$_$.v1 = GeneratedSerializer;
  _.$_$.w1 = InlineClassDescriptor;
  _.$_$.x1 = InlinePrimitiveDescriptor;
  _.$_$.y1 = NamedValueDecoder;
  _.$_$.z1 = PluginGeneratedSerialDescriptor;
  _.$_$.a2 = SerializerFactory;
  _.$_$.b2 = jsonCachedSerialNames;
  _.$_$.c2 = throwMissingFieldException;
  _.$_$.d2 = EmptySerializersModule_0;
  _.$_$.e2 = DeserializationStrategy;
  _.$_$.f2 = KSerializer;
  _.$_$.g2 = MissingFieldException;
  _.$_$.h2 = SealedClassSerializer;
  _.$_$.i2 = SerializationException;
  _.$_$.j2 = findPolymorphicSerializer;
  _.$_$.k2 = serializer;
  //endregion
  return _;
}));
